import { createI18n } from "vue-i18n";

const messages = {
  "en-ZA": {
    global: {
      tutorial: "Tutorial",
      view_detail: "View Detail",
      thread_names: {
        english: {
          oral_comprehension: "Oral Comprehension",
          written_comprehension: "Written Comprehension",
          visual_communication: "Visual Communication",
          language_structure: "Language Structure",
        },
        maths: {
          numbers: "Numbers",
          fractions: "Fractions",
          measurements: "Measurements",
          data_literacy: "Data Literacy",
          problem_solving: "Problem Solving",
          patterns_algebra: "Patterns & Algebra",
          space_shape: "Space & Shape",
        },
      },
      filters: {
        choose_grade: "Choose Grade",
        grade: "Grade",
        filter: "Filter",
        clear: "Clear",
        grades: "Grades",
        filter_by_class: "Filter by Class",
        all: "All",
        apply_filters: "Apply Filters",
        search: "Search",
      },
      grade_naming_convention: "Grade",
    },
    internal_view: {
      header: "What would you like to edit?",
      subheader: "Select an option below to get started",
      edit_school: "Edit school details",
      edit_student: "Edit student details",
      archive_option: "Archive/Unarchive",
      wonde: {
        intro: "Import and sync Wonde students, teachers and class groups.",
        header: "Wonde School Sync",
        description:
          "Select an approved Wonde school. Once you've made your selection and filled in the relevant details, click the confirm button at the bottom to begin the sync process. Please allow enough time for the syncing process to complete depending on the number of students, classes and teachers.",
        all_teachers: "All Teachers",
        all_classgroups: "All Grades",
        school_created_success:
          "School created and the sync operations have begun. Check back in 15 minutes to see the results.",
        btn_school_details: "School details",
        btn_grades_classes: "Grades & Classes",
        btn_teacher_details: "Teacher details",
        btn_create_and_sync: "Create School & Sync",
      },
      delete_champion_success: "Success! Champion deleted successfully.",
      delete_champion_error: "Error deleting champion. Please try again.",
      delete_teacher_success: "Success! Teacher deleted successfully.",
      delete_teacher_error: "Error deleting teacher. Please try again.",
      track_screen: {
        engagement: "Engagement",
        teacher_onboarding: "Teacher onboarding completion",
        changes_made: "Changes made",
        pending_rollover: "Schools pending rollover completion",
        schools: "Schools",
        rollover_not_started: "Rollover not started",
        pending_completion: "Pending completion",
        class_review_progress: "Class review in progress",
        learner_assignment_pending: "Learner assignment pending",
        no_user_assigned: "No user assigned",
        no_school_assigned: "No school assigned",
        rollover_review: "Rollover in review"
      }
    },
    archive_flow: {
      done: "Done",
      view: "View",
      archive_btn: "Archive",
      unarchive_btn: "Unarchive",
      upload: "Upload",
      search_and_load: "Search and Load",
      upload_header: "Upload list of students to archive",
      select_all: "Select all",
      grade_not_selected: "Grade not selected",
      learners_table: {
        name: "Name",
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        class: "Class",
        subject: "Subject",
        country: "Country",
        language: "Language",
        level: "Level",
        school: "School",
        grade: "Grade",
        status: "Status",
        teacher_name: "Teacher name",
        add_students: "Add [students]",
        student_number: "Student number",
        password: "Password",
      },
      english: "English",
      afrikaans: "Afrikaans",
      selected: "selected",
      upload_preview_header: "upload preview",
      back: "Back",
      preview_selection: "Preview selection",
      archive_students: "Archive students",
      unarchive_students: "Unarchive students",
      cancel: "Cancel",
      complete_assign: "Complete and assign [students]",
      complete_assign_learners: "Complete and assign learners",
      modals: {
        complete: "Complete",
        success_message: "You have successfully queued the chosen learners to be {type}.",
        close: "Close",
        incomplete: "Incomplete",
        error_message:
          "Something went wrong, please try again later or contact support",
        confirm_selection: "Confirm your selection",
        youve_selected: "You've selected",
        students_move: "students to move to",
        edit: "Edit",
        correct: "Yes, that's correct",
      },
      greeting_block: {
        greeting: "Hello",
        welcome_text:
          "Welcome to the Admin View (here you can manage school and student details)",
      },
    },
    file_upload_component: {
      click_upload: "Click to upload",
      drag_drop: "or drag and drop",
      accepted_files: "XLSX, CSV, JPG or GIF (MAX. 800x400px)",
      preview: "Preview",
      help_text: "Not sure what information you need?",
      download_template: "Download a template",
    },
    admin_screens: {
      main_title: "Admin",
      tutorial: "Tutorial",
      grade_and_classes: "Grades & classes",
      teacher_details: "Teacher details",
      grade: "Grade",
      students: "Students",
      bulk_upload_students: {
        overview: "Overview",
        school_details: "School details",
        student_details: "Student details",
        students: "students",
        student_number: "Student number",
        password: "Password",
        back: "Back",
        cancel: "Cancel",
        submit: "Submit",
        class_group: "Class group",
      },
      modals: {
        almost: "You're almost done!",
        check_email_text: "Keep an eye on your email for updates",
        additional_text: "and additional information",
        note_text: "NOTE: this process can take a few minutes",
        add_new_grade_header: "Add a new grade",
        remove_grade_header: "Remove a grade",
        are_you_sure: "Are you sure you want to add",
        are_you_sure_remove: "Are you sure you want to remove",
        to_the_program: "to the program",
        from_the_program: "from the program",
        cancel: "Cancel",
        im_sure: "I'm sure",
      },
      teacher_details_screen: {
        add_teacher: "Add Teacher",
        teacher_details: "Teacher details",
        cancel: "Cancel",
        save_changes: "Save changes",
        students: "students",
        assigned_classes: "Assigned Classes",
        status: "Status",
      },
      grades_and_classes_screen: {
        header: "Which subjects will they be using on Reflective Learning?",
        grade: "Grade",
        assigned_teachers: "Assigned teacher",
        language: "Language of learning",
        deletion_marked: "This class is marked for deletion!",
        students: "students",
        new_teacher_text: "This will be the new teacher. Current Teacher is",
        deletion_unmarked: "Unmark this class for deletion!",
        new_class_added: "This is a new class to be added!",
        add_class: "Add Class",
        cancel: "Cancel",
        save_changes: "Save changes",
        update_success: "Successfully updated",
        cant_do_that: "Yikes! Can't do that.",
        error_text:
          "We can't delete a class with students in it. First move students to another class, or remove them, before deleting the class.",
        go_back: "Go back",
        class_name: "Class Name",
        select_teacher: "Select A Teacher",
        validation_message: "One or more classes are missing a name or preferred language.",
        locked_journeys: "Locked Journeys",
        duplicate_class_name_error: "Duplicate class names detected:",
      },
      alerts: {
        success_saved: "Successfully saved",
        success_updated: "Successfully updated",
      },
    },
    bulk_learner_upload_component: {
      generate_emails_modal: {
        header:
          "Do you have an email address for <br/> all of the students in this {uploadType}?",
        sub_header:
          "If not, we will autogenerate an email address for them to login <br/> with the following structure:",
        email: "name.surname&#64;schoolname.co.za",
        btn_yes: "Yes I do",
        btn_generate: "Generate for me",
        grade_label: "school",
        class_label: "class",
        file_upload_header: "Upload new learners",
        assessment: "Assessment"
      },
      preview_learners: {
        grade: "Grade",
        class: "Class",
        header: "Bulk upload new students to",
        license_status: " {used}/{total} Licenses used",
        license_limit_error_title: "Licenses Exceeded",
        license_limit_error_content:
          "There are not enough licenses available. Please contact your admin to purchase more.",
        table: {
          email: "Email",
          first_name: "First name",
          last_name: "Last name",
          student_number: "Student number",
          password: "Password",
          new_email: "New email",
          locale: "Language",
          learningMode: "Learning Mode",
        },
        btn_back: "Back",
        btn_cancel: "Cancel",
        btn_submit: "Submit",
        email_validation: "Sorry, that email is taken. Try a different one.",
        email_invalid: "Please enter a valid email address",
        license_validation:
          "You have run out of available licenses. Please contact support to request more",
        error_alert_title:
          "These learners have already been registered. Do you want to submit anyways to update their accounts?",
        error_alert_button_label: "Continue Submission",
        email_duplicate: "This email appears more than once in your list. Please use a unique email.",
        locked_journeys: "Locked Journeys",
        catchup: "Catchup",
        assessment: "Assessment",
      },
      modal: {
        header: "You’re almost done!",
        sub_header:
          "Keep an eye on your email for updates <br/> and additional information",
        important_info: "NOTE: this process can take a few minutes",
      },
      invalid_data_modal: {
        heading: "Unable to Proceed",
        name_surname: "One or more learners are missing either their first name or last name.",
        required_class: "One or more learners are missing either a Maths class or an English class.",
        password: "One or more learners have passwords that are missing or too short (minimum 6 characters)",
        email: "One or more learners are missing their email addresses.",
        grade_invalid: "One or more learners have an invalid grade. Grade must be a valid number and cannot be empty",
        journeys: "One or more learners are missing their journeys.",
      }
    },
    bulk_learner_edit_component: {
      edit_multiple: "Edit multiple students",
      edit_student: "Edit student",
      select_options: "Select the options you would like to change",
      number_selected: "selected",
      class: "Class",
      english: "English",
      select: "Select",
      maths: "Maths",
      locked_journeys: "Locked journeys",
      none: "None",
      catchup: "Catchup",
      assessment: "Assessment",
      language: "Language",
      afrikaans: "Afrikaans",
      btn_cancel: "Cancel",
      btn_save: "Save changes",
      status: "Status",
      modal: {
        header: "Success",
        sub_header:
          " You have successfully made <br/> changes to {count} students",
        failed_header: "Failed",
        sub_header_failed:
          "Changes to {selectedStudents} students were not successful.",
        success_update: "'s details were successfully updated!",
        changes: "Changes to",
        not_successful: "'s details were not successful",
      },
      updating_learners: "Updating..",
      updating_learner: "Updating..",
    },
    students_view: {
      search: "Search for an individual student",
      students: "students",
      done: "Done",
      no_assigned_classes: "Unassigned Students",
      btn_upload: "Bulk Upload Learners",
      view: "View",
      print_passwords: {
        print_class_btn: "Print Class Logins",
        print_school_btn: "Print School Logins",
        modal_header: "Print Logins",
        modal_description_single_intro: "There are more than 100 students selected.",
        modal_description_single: "Generating login cards for a large number of students may take some time.",
        modal_description_multiple_intro: "Login cards will be generated for all classes within this grade. ",
        modal_description_multiple: "This may take a few minutes and the download will begin once processing is completed.",
        modal_proceed_text: "Would you like to proceed?",
        modal_cancel_btn: "Cancel",
        modal_proceed_btn: "Proceed"
      }
    },
    student_table_view: {
      new_student: "Add student",
      bulk_upload: "Bulk upload",
      bulk_edit: "Bulk edit",
      add_student: "Add Student",
      generate: "Generate",
      table: {
        last_name: "Last name",
        last_name_example: "Doe",
        first_name: "First name",
        first_name_example: "John",
        email: "Email",
        email_example: "firstname.surname{char}school.co.za",
        student_number: "Student number",
        password: "Password",
        password_example: "Password",
        status: "Status",
      },
      btn_cancel: "Cancel",
      btn_submit: "Add",
      modal_cancel: {
        header: "Are you sure?",
        sub_header: "Any information you have entered will be lost.",
        btn_cancel: "Cancel",
        btn_sure: "I’m sure",
      },
      confirm_modal: {
        title: "Complete",
        details: "You've added:",
        to: " has been successfully added to the student list of class ",
        btn_edit: "Done",
        btn_correct: "Yes, that’s correct",
      },
      overview_modal: {
        grade: "Grade",
        class: "Class",
        english: "English",
        maths: "Maths",
        tutorial: "Tutorial",
        overview: "Overview",
        journey: "Journey",
        activity: "Activity",
        activity_tab: {
          graph_header: "The past Month",
          min: "min",
          average_weekly: "Average weekly active time",
          time_learning: "of time spent learning",
          ahead: "ahead",
          on_track: "on track",
          falling_behind: "falling behind",
          daily_tasks_complete: "Expected daily tasks complete",
          download_pdf: "Download Individual PDF Report",
        },
        tooltips: {
          average_weekly_active_time:
            "Total amount of App time per active week in the last 30 days.",
          time_spent_learning:
            "Percentage of total active time that is spent learning (eg. assessments, catch up lessons, practice, etc)",
          expected_daily_tasks_complete:
            "A summary of where the student is tracking against their expected daily task completion to date",
          daily_tasks_complete: "Expected daily tasks complete",
          active_learning_tasks_graph:
            "Time spent on the programme, including total active time (logged in), time spent learning, and days with completed tasks",
          current_mastery_card:
            "Baseline and current level of mastery per journey (darker shades show improvement)",
          weekly_active_time:
            "The average active time per week over the past 30 days",
          time_spent_learning_card:
            "Percentage of total active time that is spent learning (eg. assessments, catch up lessons, practice, etc)",
        },
      },
    },
    login_view: {
      title: "Welcome back",
      sub_title: "Welcome back! Please enter your details.",
      email_label: "Email",
      email_placeholder: "Enter your email",
      email_required: "Email is required.",
      email_length: "Please enter a valid email address.",
      password_label: "Password",
      password_placeholder: "Enter your password",
      password_required: "Password is required.",
      password_length: "Must be at least 6 characters.",
      forgot_password: "Forgot password",
      btn_sign_in: "Sign in",
      dont_have_account: "Don’t have an account?",
      email: "help&#64;reflective.com",
      sign_up: "Sign up",
      student_login: "You're a student? Login below.",
      student_login_btn: "Student Login",
      advanced_options: "Advanced",
      region_label: "Region",
      region_automatic: "Automatic",
      region_changed_notice:
        "We have updated how Mission Control connects to your region, so you have been signed out once. Please sign in again to continue.",
      school_moved_notice:
        "Your school has moved to a new region, so you have been signed out. Please sign in again to continue.",
      school_moved_account_not_moved:
        "{school} has moved to {region}, and your account has not moved with it yet. Please contact support.",
    },
    forgot_password_view: {
      title: "Reset Password",
      sub_title: "Please enter your email.",
      email_label: "Email",
      email_placeholder: "Enter your email",
      email_required: "Email is required.",
      email_length: "Please enter a valid email address.",
      btn_reset: "Reset Password",
      btn_resetting: "Resetting Password..",
      back_to_login: "Already have an account?",
      email: "help&#64;reflective.com",
      login: "Log in",
    },
    reset_password_view: {
      title: "Set a new password",
      sub_title: "Please enter your new password.",
      email_label: "Email",
      email_placeholder: "Enter your email",
      password_label: "New password",
      password_placeholder: "Enter your new password",
      password_required: "Password is required.",
      password_length: "Must be at least 6 characters.",
      confirm_password_label: "Confirm Password",
      confirm_password_placeholder: "Confirm your new password",
      confirm_password_required: "Confirm password is required.",
      confirm_password_confirm: "Passwords do not match.",
      btn_reset: "Reset Password",
      btn_resetting: "Resetting Password..",
      back_to_login: "Already have an account?",
      login: "Log in",
      email: "help&#64;reflective.com",
      invalid_link: "This reset link is invalid or has expired.",
      request_new: "Request a new link",
    },
    complete_registration_view: {
      title: "Teacher / Educator Setup",
      sub_title: "Complete your account setup below.",
      email_label: "Email*",
      email_placeholder: "Enter your email",
      email_required: "Email is required.",
      email_length: "Please enter a valid email address.",
      password_label: "Password*",
      password_placeholder: "Enter your password",
      password_required: "Password is required.",
      password_length: "Must be at least 6 characters.",
      confirm_password_label: "Confirm Password*",
      confirm_password_placeholder: "Confirm password",
      confirm_password_required: "Confirm password is required.",
      confirm_password_confirm: "Passwords do not match.",
      btn_complete: "completing registration",
      btn_get_started: "Get started ",
      already_have_account: "Already have an account?",
      copyright: "&copy; Reflective Learning 2024",
      email: "help&#64;reflective.com",
      login: "Log in",
      courtesy_title: "Title",
      select: "Select",
      title_validation: "Title is required.",
      button_required_message:
        "Sorry, not all fields are filled out correctly.",
      btn_refresh_link: "Resend Link",
      btn_loading_refresh_link: "Sending Link...",
      refresh_link_title: "Your registration link is invalid or has expired.",
      refresh_link_subtitle: "Enter your email address below to request a new registration link.",
      refresh_link_success: "A new link has been sent to your email.",
      refresh_link_failure: "Failed to resend link.",
      refresh_link_error: "Something went wrong. Please contact support at: support@reflectivelearning.co.za"
    },
    add_grades_class_component: {
      btn_next: "I'm done! Take me to Step",
      btn_no_teachers_complete: "Complete now",
      stepper: {
        steps: {
          step_1: "Step 1",
          step_2: "Step 2",
          step_3: "Step 3",
          step_4: "Step 4",
        },
        circle_1: {
          add_account: "Add Accounts",
          add_teacher: "Add Teachers",
        },
        circle_2: {
          add_grade: "Grades and Classes",
          describe_grade: "Add grades and classes",
        },
        circle_3: {
          add_asssign: "Assign",
          describe_assign: "Assign teachers to classes",
        },
        circle_4: {
          review: "Review",
        },
      },
      step_0: {
        title: "Admin",
        subtitle:
          "Manage your team members and their account permissions here.",
        school_structure: "Setup your school structure",
        tell_us: "Tell us about your school structure below.",
        btn_start: "Get Started",
      },
      step_1: {
        title: "Add Teachers",
        subtitle:
          "Add your teachers to the system so that they can manage their classes and students.",
        name: "Name",
        mr: "Mr.",
        ms: "Ms.",
        mrs: "Mrs.",
        dr: "Dr.",
        surname: "Surname",
        position: "Position",
        email: "Email",
        phone_number: "Phone number",
        sa: "SA",
        btn_add: "Add another",
        btn_add_a_teacher: "Add a Teacher",
        email_exists: "Email already exists!",
        delete_teacher_confirm: "Please confirm that you would like to delete this class group teacher.",
        invalid_email: "Please enter a valid email address",
      },
      step_2: {
        title: "What grades that will be using Reflective Learning?",
        grade: "Grade",
        subject: "Which subjects will they be using on Reflective Learning?",
        english: "English",
        maths: "Maths",
        validation: {
          language: "One or more classes are missing a preferred language.",
          className: "One or more classes are missing a class name.",
          subject: "One or more classes are missing a selected subject.",
          grade: "One or more selected grades have no assigned classes."
        }
      },
      step_3: {
        grade: "Grade",
        english: "English",
        subject:
          "Which subjects will they be using on <br/> Reflective Learning?",
        select_teacher: "Select Teacher",
        maths: "Maths",
        assign_teacher: "Assign Teachers",
        btn_review: "Next: Review Setup",
      },
      step_4: {
        classes: "Classes",
        send_login: "Send login details",
        send_details:
          "Send details to the teachers that you've added to this system for them to complete their registration.",
        btn_send: "Send logins",
        send_login_no_teachers: "Complete process",
        send_details_no_teachers:
          "No teachers have been added, this can be done later through the admin page. Continue to finish the school setup.",
        btn_send_no_teachers: "Continue",
        success: "Success",
        success_message: "Login details successfully sent to all teachers",
        btn_done: "Done",
        btn_confirm: "Confirm information",
        btn_view: "View Dashboard",
        not_yet: "Not ready yet?",
        review_teachers: "Review Teachers and Classes",
        edit: "Edit Teachers and Classes",
        sending: "Sending...",
        btn_save: "Save my Progress",
      },
    },
    loaders: {
      admin_store: {
        creatingAdmin: "Creating a new admin...",
        updatingAdmin: "Updating an admin...",
        fetchingAllAdmins: "Fetching all admins...",
        fetchingSingleAdmin: "Fetching a single admin...",
        deleteAdmin: "Deleting an admin...",
      },
      learner_store: {
        fetchSchoolLearners: "Fetching learners...",
        createLearner: "Creating learner...",
        updateLearner: "Updating...",
        bulkCreateLearners: "Creating learners...",
        bulkArchiveLearners: "Archiving learners...",
        validateEmail: "Validating email...",
      },
      license_store: {
        fetching_Licenses: "Fetching Licenses",
        request_seats: "Requesting more seats",
        creating_license: "Creating a new license",
        updating: "Updating...",
      },
    },
    activity_view: {
      header: "Activity",
      all: "All",
      cards: {
        active_last_7_days: "active in the last 7 days",
        average_time: "average active time",
        time_learning: "of time spent learning",
        total_active_users: "total active users",
        on_track: "on track with tasks",
      },
      activity_summary_per_class_card: {
        header: "Activity Summary per Class",
        subheader: "Keep track of vendor and their security ratings",
        classes: "Classes",
        last_30_days: "Last 30 days",
        last_7_days: "Last 7 days",
        vendor: "Vendor",
        class: "Class",
        average_minutes: "Average Minutes",
        daily_tasks: "Daily Tasks",
        min: "min",
        page: "Page",
        of: "of",
        previous: "Previous",
        next: "Next",
      },
      metting_engagement_requirement_card: {
        header: "Meeting engagement requirements",
        subheader: "% of students with at least 30 minutes of activity",
        month: "June",
      },
      activity_summary_per_student_card: {
        header: "Activity Summary per Student",
        subheader: "Keep track of vendor and their security ratings",
        student: "Student",
      },
      login_task_completion_card: {
        header: "Login vs Task Completion",
        subheader: "in the last 30 days",
      },
      tooltips: {
        active_last_7_days: "Active in the last 7 days",
        average_time: "Average active time",
        time_learning: "of time spent learning",
        total_active_users: "Total active users",
        on_track: "On track with tasks",
        activity_summary_student: "Activity Summary per Student",
        activity_summary_class:
          "A class breakdown of the average active minutes per student, and the percentage of students who completed their assigned tasks",
        meeting_engagement_requirements:
          "Percentage of students who met the minimum engagement expectations per week, for the last 4 weeks",
        login_vs_task_completion: "Login vs Task Completion",
        current_mastery:
          "Baseline and current level of mastery per journey (darker shades show improvement)",
        concept_mastery:
          "Baseline and current level of mastery per journey (darker shades show improvement)",
        class_activity_30_days: "The total learning time for the 30 days per active student.",
        class_activity_7_days: "The total learning time for the week per active student.",
        student_activity_30_days: "The total learning time for the 30 days per active day.",
        student_activity_7_days: "The total learning time for the week per day.",
      },
    },
    overview_page: {
      rollover_view: {
        header: "Let's get started",
        subheader: "Your classes are currently empty",
        add_students: "Add Students",
        students: "Students",
        all_learners_assigned_in_grade: "All learners assigned in grade",
        all_teacher_classes_have_at_least_one_student:
          "All your classes have at least one student. Please wait for your school admin to complete rollover.",
        table_component: {
          header: "Add students to class",
          class: "Class",
          last_name: "Last name",
          first_name: "First name",
          email: "Email",
          previous_class: "Previous Class",
          grade: "Grade",
          back: "Back",
          submit: "Submit",
          previous_class_label: "Filter by Previous Class",
          all_classes_text: "All Classes",
          confirm_modal: {
            header: "Confirm your selection",
            selected_text: "You've selected",
            text: "students assigned to",
            edit: "Edit",
            correct: "Yes, that's correct",
          },
        },
      },
      header: "My Classes",
      active: "active",
      average_gaps: "Avg. gaps per student",
      gaps_per_student: "Gaps per students",
      active_last_7_days: "Active in the last 7 days",
      student_active: "Students active",
      active_time: "Avg. time on app per student",
      min: "min",
      per_week: "per week",
      time_spent_learning: "Avg. time spent learning",
      daily_tasks: "Task Completion",
      students: "Students",
      most_active_class: "Class Activity",
      this_week: "Last 30 Days",
      most_active: "Most Active",
      least_active: "Least Active",
      students_active: "students",
      minutes_average: "min. average",
      at_glence: "Students on track",
      on_track: "On Track",
      falling_behind: "Falling behind",
      ahead: "Ahead",
      announcements: "Announcements",
      reflection_questions: "Reflection Question Performance",
      numbers: "Numbers",
      fractions: "Fractions",
      measurements: "Measurements",
      data_literacy: "Data Literacy",
      problem_solving: "Problem Solving",
      patterns: "Patterns & Algebra",
      space: "Space & Shape",
      visual: "Visual Communication",
      oral: "Oral Comprehension",
      written: "Written Comprehension",
      language: "Language Structure",
      tasks_completed: "Learners who have completed the tasks",
      tooltips: {
        avg_gaps: "Avg. gaps per student",
        active_last:
          "Percentage of students who have logged in in the last 7 days",
        active_time:
          "The average amount of time that each active student is engaging in with learning in the past 7 days",
        time_learning:
          "Percentage of total active time that is spent learning (eg. assessments, catch up lessons, practice, etc)",
        reflection_question: "Reflection Question Performance",
        daily_task:
          "The number of students, per week, who have completed their assigned tasks",
        class_activity: "Class Activity",
        at_a_glance:
          "A breakdown of how students are tracking against their expected daily task completion to date",
      },
    },
    journeys_view: {
      journeys: "Journeys",
      students_at_expected_level: "Students at Expected Level",
      students: "students",
      current_mastery: "Current Mastery",
      baseline_completion: "Baseline Completion",
      incomplete: "incomplete",
    },
    concepts_view: {
      header: "Concepts",
      baseline_incomplete: "of students have not completed the baseline assessment",
      to_be_assessed: "students to be assessed",
      proficiency_by_concept: "Proficiency by concept",
      mastery_at_required_level: "Mastery at required level",
      no_data: "No data for the current filter",
      tooltips: {
        proficiency_by_concept:
          "How assessed students are spread across all four proficiency levels for each concept in the selected journey. The top level, shown in dark green, is 'At Expected'.",
        mastery_toggle:
          "Average across this journey's concepts of the percentage of assessed students at the Expected level. 'Start' uses each student's first attempt and 'Current' uses their most recent attempt. Students who have not been assessed yet are not counted, so this is a share of assessed students, not of the whole class.",
        mastery_at_required_level:
          "For each concept, the percentage of assessed students who have reached the Expected level, the top level. Students who have not been assessed yet are excluded.",
      },
      toggle: {
        start: "Start",
        current: "Current",
      },
      table: {
        concept: "Concept",
        start: "Start",
        current: "Current",
      },
      modal: {
        no_description: "No description available for this concept yet.",
        students_at_level: "Students at this level",
        no_students: "No students at this level.",
        cancel: "Cancel",
        confirm: "Confirm",
      },
    },
    overview_modal: {
      past_month: "The past Month",
      weekly_active: "Weekly active time",
      min: "min",
      time_spent: "Time spent learning",
      daily_tasks: "Daily tasks complete",
      level: "Level",
      incomplete: "Incomplete",
      baseline: "Baseline",
      latest: "Latest",
      grade_level_mastered: "Grade level mastered",
      individual_students: "Individual students",
      expected_level: "Expected Level",
      levels_achieved: "Levels Achieved",
      current_mastery: "Current Mastery",
    },
    journey_modal: {
      current_mastery: "Current Mastery",
      select_journey: "Select a Journey on the left to view details",
      concepts_mastered: "Concepts Mastered",
      gaps_remaining: "Gaps Remaining",
      current_trophy: "Current Trophy",
      mastery: "Mastery",
      mastered: "Mastered",
      not_mastered: "Not Mastered",
      level: "Level",
      language_structure_mastery:
        "Detailed look at the journey mastery, including gaps, trophy achieved, and individual concept mastery breakdown",
    },
    update_student: {
      title: "Edit Student",
      personal: {
        personal: "Personal",
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        password: "Password",
        student_number: "Student number",
        message: "Must be at least 6 characters",
        email_exists: "Email already exists.",
        email_invalid: "Email is invalid.",
      },
      settings: {
        settings: "Settings",
        grade: "Grade",
        locked_journeys: "Locked journeys",
        country: "Country",
        catchup: "Catchup",
        assessment: "Assessment",
        none: "None",
        status: "Status",
      },
      subject: {
        subject: "Subject",
        class: "Class",
        assessment_level: "Assessment level",
        assessment_level_validation: "Only one level change is allowed.",
        language: "Language of learning",
      },
    },
    journey_view: {
      header: "Journey",
      tooltips: {
        student_at_expected_level:
          "Percentage (and count) of students who have fully mastered each journey at the level expected of them",
        current_mastery:
          "The baseline and current level of mastery per student per journey (darker shades show improvement)",
        baseline_completion: "Baseline completion",
      },
    },
    reports_view: {
      header: "Reports",
      modal: {
        title: "Preparing Report",
        message:
          "We are preparing your report currently. It will be emailed to you in the next 5 - 10 mins. If you do not receive it, please contact {email}",
        button: "Go back to dashboard",
        date_range: "Confirm Download Date Range:",
        download_btn: "Download Report"
      },
      reports: {
        "ready-for-reassessment": {
          name: "Ready for a reassessment",
          subTitle: "Per students",
        },
        "current-levels-achieved": {
          name: "Current levels achieved",
          subTitle: "List of students",
        },
        "incomplete-baseline-assessments": {
          name: "Incomplete baseline assessments",
          subTitle: "Per students",
        },
        "concept-mastery-achieved-per-student": {
          name: "Concept mastery achieved per student",
          subTitle: "A detailed breakdown",
        },
        "summary-of-concept-mastery": {
          name: "Summary of concept mastery",
          subTitle: "Baseline & Current",
        },
        "detailed-activity-for-last-7-days": {
          name: "Detailed activity for last 7 days",
          subTitle: "Minutes per student",
        },
        "detailed-activity-for-last-30-days": {
          name: "Detailed activity for last 30 days",
          subTitle: "Minutes per student",
        },
        "detailed-activity-for-last-90-days": {
          name: "Detailed activity for last 90 days",
          subTitle: "Minutes per student",
        },
        "inactive-for-7-days": {
          name: "Inactive for 7 days",
          subTitle: "List of students",
        },
        "inactive-for-30-days": {
          name: "Inactive for 30 days",
          subTitle: "List of students",
        },
        "inactive-for-90-days": {
          name: "Inactive for 90 days",
          subTitle: "List of students",
        },
        "pdf-bulk-download": {
          title: "Learner PDF Reports",
          name: "Bulk Download",
          subtitle: "Download link will be emailed to you.",
        },
        "graduates": {
          name: "Graduates",
          subtitle: "Students with 100% concept mastery for an assessment.",
        },
        "high-engagement": {
          name: "Student Engagement",
          subtitle: "Students with the highest engagement.",
        },
        "continued-improvement": {
          name: "Continued Improvement",
          subtitle: "Students with the highest improvement.",
        }
      },
    },
    admin_overview_component: {
      activity_by: "Activity By Class",
      class: "Class",
      last_login: "Last Login <br />(on dashboard)",
      average_min: "Average Min. <br />(Goal: 30 min)",
      daily_tasks: "Daily Tasks <br />(Goal: 80%)",
      days_ago: "days ago",
      licenses_used: "Licenses used",
      explore_premium: "Explore premium",
      btn_add: "Add Licenses",
      noticeboard: "Noticeboard",
      sec: "sec",
      hr: "hr",
      min: "min",
      license_modal: {
        request_license: "Request License",
        license_requried: "Additional licenses requeire admin approval",
        used: "licenses used",
        grade: "Grade",
        licenses: "licenses",
        how_many: "How many additional licenses would you like to request?",
        chat_to_us: "Chat to us",
        btn_cancel: "Cancel",
        submit: "Submit Request",
      },
    },
    profile_view: {
      title: "My Profile",
      personal_info: "Personal Info",
      update_details: "Update your photo and personal details here.",
      name: "Name",
      name_placeholder: "Your First Name",
      surname_placeholder: "Your Surname",
      email: "Email address",
      email_placeholder: "Email Address",
      photo: "Your Photo",
      your_profile: "This will be displayed on your profile",
      profile_alt: "Profile Picture",
      btn_delete: "Delete",
      btn_update: "Update",
      btn_cancel: "Cancel",
      designation: "Designation",
      designation_placeholder: "My Role",
      instagram: "Instagram",
      instagram_placeholder: "Instagram",
      linkedIn: "LinkedIn",
      linkedIn_placeholder: "Linkedin",
      updating: "Updating",
      save: "save",
      settings: "Settings",
      update_account: "Update Account Settings",
      password: "Password",
      input: {
        required: "This field is required",
        length: "Should be more than 6 characters",
        profile_alt: "Profile Picture",
      },
      change_password: "Change Password",
      current_password: "Current Password",
      new_password: "New Password",
      confirm_new_password: "Confirm New Password",
      updating_password: "Updating Password",
      update_password: "Update Password",
      confirm_password: "New password and confirm password do not match.",
      no_user: "No user is signed in.",
      incorrect_password: "Current password is incorrect.",
      weak_password: "New password is too weak.",
      failed_update: "Failed to update password.",
    },
    admin_view: {
      header: "Admin",
      tooltips: {
        activity_by_class_card: "User activity summary per class.",
        licenses_card: "School Licenses usage.",
        noticeboard_card: "Notices and Announcements",
      },
      modals: {
        complete_class_review: {
          class_structure: "Class structure complete",
          final_step: "The final step is just around the corner.",
          soon_get_emails:
            "Teachers will soon receive an email that will guide them in assigning [students] to their new classes.",
          btn_confirm: "Confirm & Close",
          not_ready: "Not ready yet?",
          come_back: "Come back later",
        },
        goto_assign: {
          almost: "Almost there!",
          final_step: "The final step is just around the corner.",
          number_students:
            "[Students] need to be assigned to their new classes.",
          assign: "Assign [students]",
          not_ready: "Not ready yet?",
          come_back: "Come back later",
        },
      },
    },
    modals: {
      teacher_class_permission: {
        title: "Action Not Allowed",
        description:
          "You do not have the necessary permissions to perform this action. Please contact your administrator if you believe this is an error.",
        btns: {
          ok: "OK",
        },
      },
      teacher_add_learners_prompt: {
        title: "Upload Learners",
        description:
          "There are no learners in this class group. Would you like to upload learners now?",
        btns: {
          cancel: "Cancel",
          ok: "OK",
        },
      },
    },
    rollover: {
      incomplete_view_screen: {
        back: "Back",
        previous: "Previous Grade",
        confirm_review_next_grade: "Confirm and review next grade",
        confirm_rollover: "Confirm & rollover",
        students: "students",
      },
      learner_rollover_table_screen: {
        grade: "Grade",
        students_selected: "students selected",
        classes: "Classes",
        all: "All",
        info_text_one:
          "Please indicate whether any students will repeat the year or leave the school, requiring their accounts to be closed",
        info_text_two:
          "Students without any selected options will be automatically moved to the next [grade/year]",
        table: {
          first_name: "First name",
          last_name: "Last name",
          email: "Email",
          class: "Class",
          repeat: "Repeat",
          remove: "Remove",
        },
        upload_button: "Upload",
        upload_title: "Upload learners",
        upload_description:
          "Are you sure you want to upload a new list of learners? This will overwrite the current selections.",
        upload_template: "Click here to download the template.",
        upload_confirm: "Confirm",
        upload_cancel: "Cancel",
      },
      review_class_structure_screen: {
        title: "Review class structures",
        sub_title:
          "Let's make sure all classes have the correct teachers assigned to them for these grades",
        grade: "Grade",
        students: "students",
        view: "View",
        back: "Back",
        confirm_email_teachers: "Confirm & email teachers",
        table_content: {
          title: "Which subjects will they be using on Reflective Learning",
          grade: "Grade",
          assigned_teachers: "Assigned teachers",
          language: "Language of learning",
          marked_for_deletion: "This class is marked for deletion",
          new_teacher_tooltip:
            "This will be the new teacher. Current Teacher is",
          unmark_class_tooltip: "Unmark this class for deletion",
          new_class_added_tooltip: "This is a new class to be added",
          add_class: "Add Class",
          cancel: "Cancel",
          save: "Save changes",
          update_success: "Successfully updated",
        },
      },
      modal: {
        confirm_date: {
          title: "We're moving all students to the next",
          starting: "starting",
          text: "Please review and confirm these changes",
          change: "Change",
          date_correct: "Date is correct",
          not_ready: "Not ready yet",
          confirm_later: "Confirm later",
          cancel: "Cancel",
          confirm_dates: "Confirm dates",
        },
        success: {
          title: "Rollover Complete",
          text: "Learners have now been assigned to their new classes. You should have received an email with the details.",
          confirm: "Confirm",
        },
        incomplete_view: {
          confirm_selection: "Confirm your selection",
          you_selected: "You've selected",
          students_to_move: "students to move to the next grade",
          students_to_remain: "students to remain in the same grade",
          students_to_remove: "students to be removed from the system",
          edit: "Edit",
          correct: "Yes, that's correct",
          review_structure: "Review class structure",
          review_text:
            "This is to ensure that classes are assigned to the correct teachers after they’ve been moved up a grade",
          do_later: "Do it later",
          review_now: "Review now",
        },
        review_class_structure: {
          class_structure_complete: "Class structure complete",
          final_step_text: "The final step is just around the corner",
          teacher_emails_text:
            "Teachers will soon receive an email that will guide them in assigning [students] to their new classes",
          confirm: "Confirm & Close",
          not_ready: "Not ready yet",
          back_later: "Come back later",
          almost_there: "Almost there",
          student_assigned_text:
            "[Students] need to be assigned to their new classes",
          assign: "Assign [students]",
          cant_do_header: "Yikes! Can’t do that",
          cant_do_subheader:
            "We can’t delete a class with students in it. First move students to another class, or remove them, before deleting the class",
          cant_do_btn: "Go back",
        },
      },
    },
    internal_tools: {
      school_champions: {
        modal: {
          confirm_title: "Confirmation required",
          confirm_text: "Please confirm that you would like to delete this school champion",
          back: "Back",
          confirm_btn: "Confirm deletion"
        }
      },
      top_bar_heading: {
        create: "Create School Group and school",
        add: "Add School",
        edit: "Edit school details",
        track: "Track",
        push: "Push",
        archive: "Archive",
        activitylogs: "Activity Logs",
        internaladmins: "Internal Admins",
        apikeys: "Public API Keys",
        regionmoves: "Move schools between regions",
      },
      top_bar: {
        create: "Create",
        add: "Add",
        edit: "Edit",
        track: "Track",
        push: "Push",
        archive: "Archive",
        activitylogs: "Activity Logs",
        internaladmins: "Internal Admins",
        apikeys: "API Keys",
        regionmoves: "Region Moves",
      },
      edit_school: "Edit school details",
      region_guard: {
        message: "Schools in this country are created in the {belongs} region, and you are signed in to {here}. Switch region and create the school there.",
        switch: "Switch region"
      },
      panel: {
        school_details: "School details",
        class_details: "Class details",
        teacher_details: "Teacher details",
      },
      form: {
        school_location: "School location",
        domain_name: "Domain name",
        city: "City",
        city_name: "City name",
        country: "Select a country",
        country_title: "Country",
        language_title: "Language",
        language: "Choose a language",
        learning_mode: "Learning Mode",
        subscription_dates: "Subscription dates",
        start_date: "Start date - Expiry date",
        grade_naming: "Grade naming convention",
        english_licenses: "English Licenses",
        maths_licenses: "Maths Licenses",
        license_type: "License type",
        emis_number: "EMIS number",
        start_month: "Month of academic year start (MM-DD)",
        month: "Month",
        end_month: "Month of academic year end (MM-DD)",
        add_champion: "Add Champion Details",
        assign_champion: "Assign Existing Champion",
        champion_name: "Name",
        champion_surname: "Surname",
        champion_email: "Email",
        champion_title: "Title",
        champion_phone: "Contact number",
        btnSaving: "Saving Changes..",
        btnSave: "Save Changes",
        school_name: "School name",
        add_existing_champion: "Add existing champion",
        select_champion: "Select Champion",
        add_existing_instructions: "Select an existing admin from another school belonging to this school group.",
        subject: "Subject",
        select_subject: "Select subject"
      },
      success: {
        btnClose: "Dismiss",
        school_message: "School details have been updated successfully",
        champions_message: "Champion(s) have been added successfully",
        school_group_update: "School group updated successfully"
      },
      select: "Select a country",
      add_school: {
        school_location: "School location is required.",
        domain_name:
          "Domain name is required. Students without email addresses will be created using this domain.",
        domain_example:
          "Domain name needs to be in a format like schoolname.com",
        city_name: "City is required.",
        couunty_name: "Country is required.",
        language: "Language is required.",
        school_name: "School name is required.",
        start_date: "Month of academic year start is required.",
        end_date: "Month of academic year end is required.",
        school_message: "School was successfully created",
        create_school: "Creating School...",
        champion_message: "{schoolAdminMessage} school champion(s) created",
        school_group_champion_message:
          "{adminMessage} school group champion(s) created",
        school_group_only:
          "Only the school group was created without any school(s)!",
        subject: "At least one subject is required.",
      },
      rollover_alert_compoent: {
        btn_start: "Start The Rollover Process",
        grade_title:
          "Grade {grade} Transition Alert: Start The Rollover Process",
        grade_sub_title:
          "We're moving students up a [Grade/Year]. Please ensure that this process has been completed for a seamless transition.",
        btnContinue: "Continue Learner Rollover Review",
        learner_text: "Learner Rollover Details: Action Required",
        please_review:
          "Please review and confirm the learners’ rollover details to continue.",
        btn_start_class: "Start Class Review",
        class_review: "Class Review: Pending Confirmation",
        learner_rollover_confirm:
          "Learner rollover confirmed. Please review and confirm class structures.",
        continue_class_review: "Continue Class Review",
        class_review_in: "Class Review: In Progress",
        class_review_details:
          "Class review details are currently being confirmed.",
        start_class_review: "Start Class Review",
        rollover_to_be: "Awaiting Rollover to be complete on {date}",
        all_details:
          "All details confirmed. Awaiting rollover execution on the scheduled date. You will receive an email once the rollover is complete.",
        assign_learners: "Assign Learners",
        learners_to_class: "Assign Learners to Classes",
        rollover_class_review:
          "Rollover and class review complete. Please assign learners to their new classes.",
        finish_assign: "Finish Assigning Learners",
        learner_assignment_pending_button: "Execute Learner Assignment",
        learner_assignment_pending_title: "Learner assignment pending",
        learner_assignment_pending_subtitle:
          "Learners have been allocated to classes and are pending execution.",
        learners_assign_in_progress: "Learner Assignment: In Progress",
        learners_assigning: "Learners are being assigned to classes.",
        rollover_complet: "Rollover Complete",
        all_steps:
          "All steps completed successfully. Teachers can now log in to see their classes.",
        error_unknown_state: "Error: Unknown State",
        unknown_state: "unknown",
        unknown_text: "The current state of the rollover process is unknown.",
      },
      school_group: {
        title: "What would you like to create?",
        sub_title: "Select an option below to get started",
        btn_single: "Individual schools",
        btn_multiple: "Group of schools",
        btn_back: "Back",
        btn_next: "Next Step",
        group_name: "Group name",
        group_description: "Group description",
        type_here: "Type here",
        group_name_validation: "Group name is required.",
        group_description_validation: "Group description is required.",
        group_details: "Group Details",
        confirm_text: "Please confirm that you would like to delete this school group champion",

      },
      single_school_component: {
        title: "Add School Group Champion Details",
        failed_school_group: "Failed to create school group.",
        faliled_school: "Failed to create school.",
        error_message:
          "An error occurred during the process. Please try again.",
      },
      multiple_schools_component: {
        no_champion: "No champion",
        schools: "New Schools",
        add_school: "Add School",
        update_school: "Update School",
        create_school: "Creating Schools...",
        school_group_not_created: "School Group was not successfully created",
        school_group_created:
          "School Group <b>{groupName}</b> was successfully created.",
        schools_created:
          "<b>{totalSchools}</b> school{plural} {verb} successfully created.",
        plural: "s",
        was: "was",
        were: "were",
        error_message: "An error occurred while creating the schools.",
        delete_message: "Are you sure you want to delete school?",
        btn_cancel: "Cancel",
        btn_delete: "Delete",
        create_license: "Create a license for the school",
      },
      edit_selection_component: {
        title: "What would you like to edit?",
        subtitle: "Select an option below to get started",
        school_details: "Edit school details",
        edit_school_group: " Edit School Group Details",
      },
      archive_selection_component: {
        title: "What would you like to archive/unarchive?",
        subtitle: "Select an option below to get started",
        archive_school_groups: "Archive School Group",
        unarchive_school_groups: "Unarchive School Group",
        archive_schools: "Archive School",
        unarchive_schools: "Unarchive School",
        archive_learners: "Archive Learners",
        unarchive_learners: "Unarchive Learners",
        back:"Go Back"
      }
    },
    "lingo_v2": {
      "grammar": {
        "level_1_description": "<p>Students demonstrate awareness of basic word classes, including nouns, verbs, adjectives, and pronouns, and apply these in simple sentences. Regular pluralisation patterns are used, with emerging control of possessives, articles, and basic prepositions such as in, on, and under. Compound words and the prefix un– are applied to show early morphological awareness.</p><p>Verbs are recognised as doing or being words, with accurate use of simple present and past tense. Short noun and verb phrases are constructed, with subject–verb agreement maintained in simple sentences. Coordinating words such as and or because are used to link ideas, and suffixes such as –ing and –ed signal tense.</p><p>Punctuation and capitalisation are applied consistently in basic contexts. Sentences begin with capital letters, proper nouns are recognised, and full stops, question marks, and exclamation marks are used accurately. Apostrophes are introduced for contractions and simple possession, and commas appear in short lists.</p>",
        "level_2_description": "<p>Students apply pluralisation accurately, including irregular forms, and demonstrate control of possessive nouns and pronouns. Determiners are selected appropriately, and reflexive pronouns are used alongside subject and object forms. Vocabulary is expanded through affixes such as re–, dis–, –ful, –ly, and –less, supporting awareness of word families.</p><p>Verb knowledge extends to continuous forms using to be and to have, alongside irregular past tense and simple future marked with will. Compound sentences are formed reliably using conjunctions such as and, but, and because, with logical sequencing maintained. Errors involving double negatives are avoided, and subject–verb agreement is sustained in extended contexts.</p><p>Punctuation is accurate for statements, questions, and exclamations, with capitalisation applied to names, places, and calendar terms. Apostrophes are used for contractions and possession, and commas are applied in longer lists or between clauses in compound sentences.</p>",
        "level_3_description": "<p>Students distinguish between collective, concrete, and abstract nouns, apply irregular plurals, and use possessive forms with accuracy. Homophone distinctions such as there/their, its/it’s, and than/then are controlled. Adjectives and adverbs are applied deliberately, with correct ordering of multiple adjectives and use of adverbial phrases.</p><p>Sentence variety includes both compound and emerging complex forms. Main and subordinate clauses are distinguished, and expanded noun phrases and adverbial clauses are used to add detail. Errors such as run-ons, comma splices, and double negatives are identified and corrected.</p><p>Verb use includes the present perfect alongside simple past, with auxiliary verbs handled accurately. Subject–verb agreement is maintained, and irregular forms are applied correctly. Punctuation extends to commas for separating clauses, quotation marks for direct speech, and consistent use of apostrophes for contractions and possession.</p>",
        "level_4_description": "<p>Students apply nouns accurately across common, proper, and abstract categories, including invariable forms and plural possessives. Homophones such as your/you’re, to/too, and then/than are distinguished with reliability. Pronoun–antecedent agreement is maintained, and adjectives and adverbs are used with precision in comparative, superlative, and modifying roles.</p><p>Complex sentences are constructed through relative clauses, embedded clauses, and a range of subordinating conjunctions. Clause function—subject, object, adverbial, and complement—is recognised and applied effectively. Sentence errors such as misplaced modifiers and run-ons are corrected, and coordination and subordination are managed fluently.</p><p>Verb use extends to past perfect, future continuous, and introductory passive forms. Conditional sentences are constructed appropriately, and subject–verb agreement is consistent within complex contexts. Punctuation includes commas for clauses and introductory phrases, apostrophes for plural possession, and quotation marks for speech.</p>",
        "level_5_description": "<p>Students demonstrate accuracy with irregular plurals, possessives, and distinctions among commonly confused homophones. Articles are chosen correctly, and pronoun use expands to interrogative and indefinite forms with consistent agreement. Adjectives and adverbs are precise and varied, while prepositions extend meaning within and across sentences.</p><p>Sentence variety includes relative and adverbial clauses, reduced relatives, and prepositional phrases that expand expression. Complex and compound–complex sentences are composed with logical sequencing, while errors such as double negatives are avoided. Coordinating, subordinating, and correlative conjunctions are used flexibly, and adverb placement strengthens clarity.</p><p>Verb use includes modal verbs expressing possibility, necessity, and certainty, alongside extended use of the passive voice. The future perfect tense is introduced and subject–verb agreement remains accurate. Punctuation incorporates colons, semicolons, parentheses, and commas before conjunctions, with apostrophes distinguishing clearly between plural and possessive forms.</p>",
        "level_6_description": "<p>Students demonstrate control of irregular and classical plural forms, alongside complex determiners such as quantifiers and distributives. Homophones and commonly confused words such as whose/who’s, affect/effect, fewer/less, and lie/lay are distinguished accurately. Pronouns are applied across all major categories, with agreement sustained consistently in extended texts.</p><p>Sentence structures include compound–complex forms, multiple subordinate clauses, and accurate use of restrictive and non-restrictive clauses. Participle and non-finite clauses extend expression, and conjunctive adverbs such as however and therefore enhance logical links. Parallel structure and comparisons are maintained, and sentence errors such as fragments and dangling modifiers are avoided.</p><p>Verb use demonstrates control of all tense forms, including perfect progressive and advanced conditionals. Passive voice is applied purposefully across tenses, and modal verbs are chosen for register and tone. Punctuation incorporates ellipses, hyphenation, and refined use of quotation marks, with capitalisation extending to proper adjectives.</p>",
        "level_7_description": "<p>Students demonstrate advanced control of all word classes, with accuracy across irregular, abstract, and collective forms. Morphological knowledge supports precise interpretation of meaning through prefixes, suffixes, and roots. Homophone and word-pair distinctions such as affect/effect, fewer/less, amount/number, and between/among are mastered, and modifiers, determiners, and pronouns are applied consistently in extended contexts.</p><p>Clause variety is integrated with fluency, including relative, adverbial, non-finite, and participle clauses placed for stylistic effect. Compound–complex sentences show accuracy and cohesion, with logical relationships expressed through conjunctions and conjunctive adverbs. Sentence rhythm and emphasis are achieved through deliberate manipulation of clause order and structure, while common errors are eliminated.</p><p>Verb use covers all tense and aspect combinations, with conditional and passive forms applied confidently across contexts. Modal verbs are employed with nuance to convey shades of meaning, and subject–verb agreement is sustained even in extended writing. Punctuation demonstrates mastery of advanced devices, including semicolons, colons, dashes, and parentheses, alongside precise handling of quotation, ellipsis, and hyphenation.</p>"
      },
      "spelling": {
        "level_1_description": "<p>Spelling demonstrates accuracy with short, regular words following consonant–vowel–consonant patterns, alongside the first set of high-frequency items. Knowledge of one-to-one sound–letter correspondences is secure, allowing students to represent most sounds consistently. Familiar sight words such as the, and, was are recognised and applied with accuracy in short sentences.</p><p>Control begins to extend to digraphs such as sh, ch, th, though these may not yet be reliable. Spelling of less familiar words is often phonetic, reflecting reliance on segmenting and blending, but approximations are recognisable and increasingly close to target forms. Attempts show developing control of word boundaries and simple morphemic patterns.</p><p>Errors are predictable and reflect immature strategies, while correct spellings are limited to the most familiar vocabulary. Functional writing communicates meaning clearly with words such as cat, dog, sun, bed, supported by a restricted but dependable spelling base.</p>",
        "level_2_description": "<p>Spelling includes accuracy with consonant blends such as br, cl, st and common digraphs such as wh, ng, th. Regular long-vowel patterns (ai, ee, oa) are applied with growing consistency, and sight words are recalled more fluently. Familiar irregular words such as said or was appear correctly spelled in extended contexts.</p><p>Inflectional endings are managed with control, including –s, –es, and –ed, with plurals handled reliably. Words show evidence of applying rules for endings such as changing y to ies. Invented spellings demonstrate partial but logical application of phonics and morphology.</p><p>Errors are generally confined to less common vowel patterns or unfamiliar longer words. Mastery is evident in items such as rain, boat, tree, black, jump, together with reliable accuracy in functional classroom writing.</p>",
        "level_3_description": "<p>Spelling demonstrates confidence with high-frequency words and regular morphemic patterns. Prefixes such as un–, re– and suffixes such as –ing, –ful, –ness are applied consistently to generate new words. Families such as happy, unhappy, happiness show awareness of meaning and form.</p><p>Control extends to r-controlled vowels (car, bird, turn) and irregular vowel spellings, including challenging forms such as ough. Multisyllabic words are attempted by breaking them into syllables, with most produced recognisably and increasingly accurately.</p><p>Errors shift from phonetic approximations toward irregular forms and unusual word families.</p><p>Representative words at this level include quickly, said, does, alongside accurate spelling of common morphological combinations.</p>",
        "level_4_description": "<p>Spelling accuracy extends to multisyllabic words, silent letters, and homophone pairs. Irregular words such as knight, island, and yacht are handled with increasing confidence. Academic vocabulary drawing on Latin or Greek origins, such as phone or graph, is spelled with accuracy.</p><p>Knowledge of morphemes supports precision across word families. For example, understanding aqua enables reliable spelling of aquarium or aquatic. Segmenting words into meaningful parts allows application of spelling knowledge beyond the most common forms. Representative words include temperature, ecosystem, their/there/they’re, showing control of both subject-based and functional vocabulary. Accuracy at this stage reflects fluency with common and less predictable structures.</p>",
        "level_5_description": "<p>Spelling demonstrates control of irregular forms, advanced affixes, and subject-specific vocabulary. Endings such as –tion, –sion, –cian are applied consistently, alongside irregular plurals. Complex words are managed reliably across a range of contexts.</p><p>Etymological knowledge supports spelling choices, particularly for loanwords from French, Latin, and Greek. Understanding of root words contributes to accuracy in formal and academic vocabulary. Representative examples include ballet, chaos, chorus, and civilisation.</p><p>Errors are largely confined to very low-frequency loanwords. Accuracy extends across longer texts, supporting clear communication in both subject-specific and general writing.</p>",
        "level_6_description": "<p>Spelling accuracy is consistent in extended writing across genres, including technical, academic, and creative contexts. Morphological contrasts such as –ible/–able and –ance/–ence are applied with confidence, demonstrating flexible word knowledge.</p><p>Loanwords and advanced subject terms are handled correctly in most contexts, reflecting integration of phonological, morphological, and etymological strategies. Errors are infrequent and usually occur only with unfamiliar or highly irregular words.</p><p>Representative items include photosynthesis, parliament, achievable, perseverance, and equation. At this stage, spelling supports fluent composition without hindering clarity or precision.</p>",
        "level_7_description": "<p>Spelling competence extends to advanced and discipline-specific vocabulary, including low-frequency and technical terms. Words of Greek, Latin, and other origins are spelled reliably, regardless of irregularity or exception to rule.</p><p>Awareness of regional conventions such as British and American spelling allows adaptation to audience and context. Accuracy is expected at all times, with errors confined to rare or specialist terms.</p><p>Representative examples include metamorphosis, jurisprudence, synchronisation, chlorophyll, and aesthetic. Spelling at this level demonstrates mastery and readiness for advanced academic or professional contexts.</p>"
      },
      "tooltips": {
        "kc_status": {
          "seen": "At least one question answered",
          "learning": "At least two errors",
          "reinforcing": "Completed blocked practice or teacher intervention. If two more errors are made after this, back to ‘Learning’",
          "not_yet_seen": "No questions answered yet",
          "mastered_new_learning": "At least two errors early on, but now with three correct in a row",
          "mastered_prior_learning": "The first two questions correct; or a single error followed immediately by three correct in a row"
        },
        "kc_arch_progress_status": {
          "seen": "Items on the list which have at least one question answered.",
          "learning": "Items on the list where at least two errors were made.",
          "mastered": "Items on the list which had the first two questions in a row answered correctly, or have had three in a row correct at any time.",
          "reinforcing": "Items on the list which were focussed on recently by the teacher, or by a ‘blocked activity’.",
          "not_yet_seen": "Items on the list which haven’t had any questions yet."
        }
      },
      "vocabulary": {
        "level_1_description": "<p>Vocabulary consists of familiar, concrete words tied to home, school, and play. High-frequency function words are recognised and used in short sentences to support basic communication.</p><p>Meaning is supported by direct physical experience and visual cues. Representative words include dog, chair, ball, apple, run, happy. Vocabulary at this level establishes the foundation for oral and written expression.</p><p>Usage remains restricted to everyday contexts, but words are applied with reliability in speech and simple writing tasks.</p>",
        "level_2_description": "<p>Vocabulary extends to descriptive terms, comparatives, superlatives, and basic prepositions. Words allow for greater variety and precision in communication.</p><p>Opposites and simple synonyms are recognised and applied, supporting categorisation and contrast. Representative examples include bigger, fastest, behind, tomorrow, dark, bright, loud.</p><p>Words at this level expand expressive capacity, enabling more detailed descriptions of people, objects, and events.</p>",
        "level_3_description": "<p>Vocabulary includes subject-related terms across mathematics, science, and the humanities. Words with multiple meanings are understood in context, and figurative expressions emerge in both oral and written language.</p><p>Morphological awareness supports word knowledge, with prefixes and suffixes applied to generate related forms. Examples include continent, fraction, evaporation, unhappy, happiness, planet.</p><p>This level reflects a shift from concrete to abstract vocabulary, supporting comprehension and expression in more academic contexts.</p>",
        "level_4_description": "<p>Vocabulary incorporates a broad range of academic terms across disciplines. Words are understood in both literal and extended senses, showing growth in abstraction and generalisation.</p><p>Representative terms include ecosystem, democracy, investigate, describe, temperature. Precision in use reflects the influence of subject learning on vocabulary expansion.</p><p>Word knowledge at this level underpins independent reading and writing, ensuring comprehension across increasingly challenging texts.</p>",
        "level_5_description": "<p>Vocabulary includes a wide range of technical and academic items. Understanding of Greek and Latin roots supports meaning and spelling, broadening access to complex terms.</p><p>Sensitivity to shades of meaning is evident, with synonyms distinguished by nuance. Examples include justify, evaluate, significance, geology, television, furious, irritated.</p><p>Usage reflects adaptability across contexts, allowing vocabulary to be chosen for formality, audience, and purpose.</p>",
        "level_6_description": "<p>Vocabulary is broad, flexible, and sophisticated. Subject-specific terminology and literary expressions are applied accurately in extended speech and writing.</p><p>Idiomatic language and register are controlled, with awareness of how word choice shapes impact and tone. Representative examples include constitution, parliament, metaphor, equation, persuade, significance.</p><p>At this stage, vocabulary supports advanced comprehension and purposeful, nuanced expression across genres.</p>",
        "level_7_description": "<p>Vocabulary extends to advanced academic and professional domains, including rare, technical, and discipline-specific terms. Connotations, idioms, and cultural references are understood and applied with precision.</p><p>Adaptation to audience and purpose is evident, with word choice reflecting both accuracy and stylistic effect. Representative words include jurisprudence, metamorphosis, synchronisation, ideology, aesthetic.</p><p>Mastery at this level equips students to engage fluently in specialised study, professional communication, and sophisticated expression.</p>"
      }
    },
  },
  "en-GB": {
    global: {
      tutorial: "Tutorial",
      view_detail: "View Detail",
      thread_names: {
        english: {
          oral_comprehension: "Oral Comprehension",
          written_comprehension: "Written Comprehension",
          visual_communication: "Visual Communication",
          language_structure: "Language Structure",
        },
        maths: {
          numbers: "Numbers",
          fractions: "Fractions",
          measurements: "Measurements",
          data_literacy: "Data Literacy",
          problem_solving: "Problem Solving",
          patterns_algebra: "Patterns & Algebra",
          space_shape: "Space & Shape",
        },
      },
      filters: {
        choose_grade: "Choose Year",
        grade: "Year",
        filter: "Filter",
        clear: "Clear",
        grades: "Years",
        filter_by_class: "Filter by Class",
        all: "All",
        apply_filters: "Apply Filters",
        search: "Search",
      },
      grade_naming_convention: "Year"
    },
    internal_view: {
      header: "What would you like to edit?",
      subheader: "Select an option below to get started",
      edit_school: "Edit school details",
      edit_student: "Edit student details",
      archive_option: "Archive/Unarchive",
      wonde: {
        intro: "Import and sync Wonde students, teachers and class groups.",
        header: "Wonde School Sync",
        description:
          "Select an approved Wonde school. Once you've made your selection and filled in the relevant details, click the confirm button at the bottom to begin the sync process. Please allow enough time for the syncing process to complete depending on the number of students, classes and teachers.",
        all_teachers: "All Teachers",
        all_classgroups: "All Years",
        school_created_success:
          "School created and the sync operations have begun. Check back in 15 minutes to see the results.",
        btn_school_details: "School details",
        btn_grades_classes: "Years & Classes",
        btn_teacher_details: "Teacher details",
        btn_create_and_sync: "Create School & Sync",
      },
      delete_champion_success: "Success! Champion deleted successfully.",
      delete_champion_error: "Error deleting champion. Please try again.",
      delete_teacher_success: "Success! Teacher deleted successfully.",
      delete_teacher_error: "Error deleting teacher. Please try again.",
      track_screen: {
        engagement: "Engagement",
        teacher_onboarding: "Teacher onboarding completion",
        changes_made: "Changes made",
        pending_rollover: "Schools pending rollover completion",
        schools: "Schools",
        rollover_not_started: "Rollover not started",
        pending_completion: "Pending completion",
        class_review_progress: "Class review in progress",
        learner_assignment_pending: "Learner assignment pending",
        no_user_assigned: "No user assigned",
        no_school_assigned: "No school assigned",
        rollover_review: "Rollover in review"
      }
    },
    archive_flow: {
      done: "Done",
      view: "View",
      archive_btn: "Archive",
      unarchive_btn: "Unarchive",
      upload: "Upload",
      search_and_load: "Search and Load",
      upload_header: "Upload list of students to archive",
      select_all: "Select all",
      grade_not_selected: "Year not selected",
      learners_table: {
        name: "Name",
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        class: "Class",
        subject: "Subject",
        country: "Country",
        language: "Language",
        level: "Level",
        school: "School",
        grade: "Year",
        status: "Status",
        teacher_name: "Teacher name",
        add_students: "Add [students]",
        student_number: "Student number",
        password: "Password"
      },
      english: "English",
      afrikaans: "Afrikaans",
      selected: "selected",
      upload_preview_header: "upload preview",
      back: "Back",
      preview_selection: "Preview selection",
      archive_students: "Archive students",
      unarchive_students: "Unarchive students",
      cancel: "Cancel",
      complete_assign: "Complete and assign [students]",
      complete_assign_learners: "Complete and assign learners",
      modals: {
        complete: "Complete",
        success_message: "You have successfully {type} the chosen learner's",
        close: "Close",
        incomplete: "Incomplete",
        error_message:
          "Something went wrong, please try again later or contact support",
        confirm_selection: "Confirm your selection",
        youve_selected: "You've selected",
        students_move: "students to move to",
        edit: "Edit",
        correct: "Yes, that's correct"
      },
      greeting_block: {
        greeting: "Hello",
        welcome_text:
          "Welcome to the Admin View (here you can manage school and student details)",
      },
    },
    file_upload_component: {
      click_upload: "Click to upload",
      drag_drop: "or drag and drop",
      accepted_files: "XLSX, CSV, JPG or GIF (MAX. 800x400px)",
      preview: "Preview",
      help_text: "Not sure what information you need?",
      download_template: "Download a template",
    },
    admin_screens: {
      main_title: "Admin",
      tutorial: "Tutorial",
      grade_and_classes: "Years & classes",
      teacher_details: "Teacher details",
      grade: "Year",
      students: "Students",
      bulk_upload_students: {
        overview: "Overview",
        school_details: "School details",
        student_details: "Student details",
        students: "students",
        student_number: "Student number",
        password: "Password",
        back: "Back",
        cancel: "Cancel",
        submit: "Submit",
        class_group: "Class group",
      },
      modals: {
        almost: "You're almost done!",
        check_email_text: "Keep an eye on your email for updates",
        additional_text: "and additional information",
        note_text: "NOTE: this process can take a few minutes",
        add_new_grade_header: "Add a new year",
        are_you_sure: "Are you sure you want to add",
        to_the_program: "to the program",
        cancel: "Cancel",
        im_sure: "I'm sure",
      },
      teacher_details_screen: {
        add_teacher: "Add Teacher",
        teacher_details: "Teacher details",
        cancel: "Cancel",
        save_changes: "Save changes",
        students: "students",
        assigned_classes: "Assigned Classes",
        status: "Status",
      },
      grades_and_classes_screen: {
        header: "Which subjects will they be using on Reflective Learning?",
        grade: "Year",
        assigned_teachers: "Assigned teacher",
        language: "Language of learning",
        deletion_marked: "This class is marked for deletion!",
        students: "students",
        new_teacher_text: "This will be the new teacher. Current Teacher is",
        deletion_unmarked: "Unmark this class for deletion!",
        new_class_added: "This is a new class to be added!",
        add_class: "Add Class",
        cancel: "Cancel",
        save_changes: "Save changes",
        update_success: "Successfully updated",
        cant_do_that: "Yikes! Can't do that.",
        error_text:
          "We can't delete a class with students in it. First move students to another class, or remove them, before deleting the class.",
        go_back: "Go back",
        class_name: "Class Name",
        select_teacher: "Select A Teacher",
        validation_message: "One or more classes are missing a name or preferred language.",
        locked_journeys: "Locked Journeys",
        duplicate_class_name_error: "Duplicate class names detected:",
      },
      alerts: {
        success_saved: "Successfully saved",
        success_updated: "Successfully updated",
      },
    },
    bulk_learner_upload_component: {
      generate_emails_modal: {
        header:
          "Do you have an email address for <br/> all of the students in this {uploadType}?",
        sub_header:
          "If not, we will autogenerate an email address for them to login <br/> with the following structure:",
        email: "name.surname&#64;schoolname.co.za",
        btn_yes: "Yes I do",
        btn_generate: "Generate for me",
        grade_label: "school",
        class_label: "class",
        file_upload_header: "Upload new learners",
        assessment: "Assessment"
      },
      preview_learners: {
        grade: "Grade",
        class: "Class",
        header: "Bulk upload new students to",
        license_status: " {used}/{total} Licenses used",
        license_limit_error_title: "Licenses Exceeded",
        license_limit_error_content:
          "There are not enough licenses available. Please contact your admin to purchase more.",
        table: {
          email: "Email",
          first_name: "First name",
          last_name: "Last name",
          student_number: "Student number",
          password: "Password",
          new_email: "New email",
          locale: "Language",
          learningMode: "Learning Mode",
        },
        btn_back: "Back",
        btn_cancel: "Cancel",
        btn_submit: "Submit",
        email_validation: "Sorry, that email is taken. Try a different one.",
        email_invalid: "Please enter a valid email address",
        license_validation:
          "You have run out of available licenses. Please contact support to request more",
        error_alert_title:
          "These learners have already been registered. Do you want to submit anyways to update their accounts?",
        error_alert_button_label: "Continue Submission",
        email_duplicate: "This email appears more than once in your list. Please use a unique email.",
        locked_journeys: "Locked Journeys",
        catchup: "Catchup",
        assessment: "Assessment",
      },
      modal: {
        header: "You’re almost done!",
        sub_header:
          "Keep an eye on your email for updates <br/> and additional information",
        important_info: "NOTE: this process can take a few minutes",
      },
      invalid_data_modal: {
        heading: "Unable to Proceed",
        name_surname: "One or more learners are missing either their first name or last name.",
        required_class: "One or more learners are missing either a Maths class or an English class.",
        password: "One or more learners have passwords that are missing or too short (minimum 6 characters)",
        email: "One or more learners are missing their email addresses.",
        grade_invalid: "One or more learners have an invalid grade. Grade must be a valid number and cannot be empty",
        journeys: "One or more learners are missing their journeys.",
      }
    },
    bulk_learner_edit_component: {
      edit_multiple: "Edit multiple students",
      edit_student: "Edit student",
      select_options: "Select the options you would like to change",
      number_selected: "selected",
      class: "Class",
      english: "English",
      select: "Select",
      maths: "Maths",
      locked_journeys: "Locked journeys",
      none: "None",
      catchup: "Catchup",
      assessment: "Assessment",
      language: "Language",
      afrikaans: "Afrikaans",
      btn_cancel: "Cancel",
      btn_save: "Save changes",
      status: "Status",
      modal: {
        header: "Success",
        sub_header:
          " You have successfully made <br/> changes to {count} students",
        failed_header: "Failed",
        sub_header_failed:
          "Changes to {selectedStudents} students were not successful.",
        success_update: "'s details were successfully updated!",
        changes: "Changes to",
        not_successful: "'s details were not successful",
      },
      updating_learners: "Updating..",
      updating_learner: "Updating..",
    },
    students_view: {
      search: "Search for an individual student",
      students: "students",
      done: "Done",
      no_assigned_classes: "Unassigned Students",
      btn_upload: "Bulk Upload Learners",
      view: "View",
      print_passwords: {
        print_class_btn: "Print Class Logins",
        print_school_btn: "Print School Logins",
        modal_header: "Print Logins",
        modal_description_single_intro: "There are more than 100 students selected.",
        modal_description_single: "Generating login cards for a large number of students may take some time.",
        modal_description_multiple_intro: "Login cards will be generated for all classes within this grade. ",
        modal_description_multiple: "This will take a few minutes and the download will be emailed to you",
        modal_proceed_text: "Would you like to proceed?",
        modal_cancel_btn: "Cancel",
        modal_proceed_btn: "Proceed - Send Email when Done"
      }
    },
    student_table_view: {
      new_student: "Add student",
      bulk_upload: "Bulk upload",
      bulk_edit: "Bulk edit",
      add_student: "Add Student",
      generate: "Generate",
      table: {
        last_name: "Last name",
        last_name_example: "Doe",
        first_name: "First name",
        first_name_example: "John",
        email: "Email",
        email_example: "firstname.surname{char}school.co.za",
        student_number: "Student number",
        password: "Password",
        password_example: "Password",
        status: "Status",
      },
      btn_cancel: "Cancel",
      btn_submit: "Add",
      modal_cancel: {
        header: "Are you sure?",
        sub_header: "Any information you have entered will be lost.",
        btn_cancel: "Cancel",
        btn_sure: "I’m sure",
      },
      confirm_modal: {
        title: "Complete",
        details: "You've added:",
        to: " has been successfully added to the student list of class ",
        btn_edit: "Done",
        btn_correct: "Yes, that’s correct",
      },
      overview_modal: {
        grade: "Year",
        class: "Class",
        english: "English",
        maths: "Maths",
        tutorial: "Tutorial",
        overview: "Overview",
        journey: "Journey",
        activity: "Activity",
        activity_tab: {
          graph_header: "The past Month",
          min: "min",
          average_weekly: "Average weekly active time",
          time_learning: "of time spent learning",
          ahead: "ahead",
          on_track: "on track",
          falling_behind: "falling behind",
          daily_tasks_complete: "Expected daily tasks complete",
          download_pdf: "Download Individual PDF Report",
        },
        tooltips: {
          average_weekly_active_time:
            "Total amount of App time per active week in the last 30 days.",
          time_spent_learning:
            "Percentage of total active time that is spent learning (eg. assessments, catch up lessons, practice, etc)",
          expected_daily_tasks_complete:
            "A summary of where the student is tracking against their expected daily task completion to date",
          daily_tasks_complete: "Expected daily tasks complete",
          active_learning_tasks_graph:
            "Time spent on the programme, including total active time (logged in), time spent learning, and days with completed tasks",
          current_mastery_card:
            "Baseline and current level of mastery per journey (darker shades show improvement)",
          weekly_active_time:
            "The average active time per week over the past 30 days",
          time_spent_learning_card:
            "Percentage of total active time that is spent learning (eg. assessments, catch up lessons, practice, etc)",
        },
      },
    },
    login_view: {
      title: "Welcome back",
      sub_title: "Welcome back! Please enter your details.",
      email_label: "Email",
      email_placeholder: "Enter your email",
      email_required: "Email is required.",
      email_length: "Please enter a valid email address.",
      password_label: "Password",
      password_placeholder: "Enter your password",
      password_required: "Password is required.",
      password_length: "Must be at least 6 characters.",
      forgot_password: "Forgot password",
      btn_sign_in: "Sign in",
      dont_have_account: "Don’t have an account?",
      email: "help&#64;reflective.com",
      sign_up: "Sign up",
      student_login: "You're a student? Login below.",
      student_login_btn: "Student Login",
      advanced_options: "Advanced",
      region_label: "Region",
      region_automatic: "Automatic",
      region_changed_notice:
        "We have updated how Mission Control connects to your region, so you have been signed out once. Please sign in again to continue.",
      school_moved_notice:
        "Your school has moved to a new region, so you have been signed out. Please sign in again to continue.",
      school_moved_account_not_moved:
        "{school} has moved to {region}, and your account has not moved with it yet. Please contact support.",
    },
    forgot_password_view: {
      title: "Reset Password",
      sub_title: "Please enter your email.",
      email_label: "Email",
      email_placeholder: "Enter your email",
      email_required: "Email is required.",
      email_length: "Please enter a valid email address.",
      btn_reset: "Reset Password",
      btn_resetting: "Resetting Password..",
      back_to_login: "Already have an account?",
      email: "help&#64;reflective.com",
      login: "Log in",
    },
    reset_password_view: {
      title: "Set a new password",
      sub_title: "Please enter your new password.",
      email_label: "Email",
      email_placeholder: "Enter your email",
      password_label: "New password",
      password_placeholder: "Enter your new password",
      password_required: "Password is required.",
      password_length: "Must be at least 6 characters.",
      confirm_password_label: "Confirm Password",
      confirm_password_placeholder: "Confirm your new password",
      confirm_password_required: "Confirm password is required.",
      confirm_password_confirm: "Passwords do not match.",
      btn_reset: "Reset Password",
      btn_resetting: "Resetting Password..",
      back_to_login: "Already have an account?",
      login: "Log in",
      email: "help&#64;reflective.com",
      invalid_link: "This reset link is invalid or has expired.",
      request_new: "Request a new link",
    },
    complete_registration_view: {
      title: "Teacher / Educator Setup",
      sub_title: "Complete your account setup below.",
      email_label: "Email*",
      email_placeholder: "Enter your email",
      email_required: "Email is required.",
      email_length: "Please enter a valid email address.",
      password_label: "Password*",
      password_placeholder: "Enter your password",
      password_required: "Password is required.",
      password_length: "Must be at least 6 characters.",
      confirm_password_label: "Confirm Password*",
      confirm_password_placeholder: "Confirm password",
      confirm_password_required: "Confirm password is required.",
      confirm_password_confirm: "Passwords do not match.",
      btn_complete: "completing registration",
      btn_get_started: "Get started ",
      already_have_account: "Already have an account?",
      copyright: "&copy; Reflective Learning 2024",
      email: "help&#64;reflective.com",
      login: "Log in",
      courtesy_title: "Title",
      select: "Select",
      title_validation: "Title is required.",
      button_required_message:
        "Sorry, not all fields are filled out correctly.",
      btn_refresh_link: "Resend Link",
      btn_loading_refresh_link: "Sending Link...",
      refresh_link_title: "Your registration link is invalid or has expired.",
      refresh_link_subtitle: "Enter your email address below to request a new registration link.",
      refresh_link_success: "A new link has been sent to your email.",
      refresh_link_failure: "Failed to resend link.",
      refresh_link_error: "Something went wrong. Please contact support at: support@reflectivelearning.co.za"
    },
    add_grades_class_component: {
      btn_next: "I'm done! Take me to Step",
      btn_no_teachers_complete: "Complete now",
      stepper: {
        steps: {
          step_1: "Step 1",
          step_2: "Step 2",
          step_3: "Step 3",
          step_4: "Step 4",
        },
        circle_1: {
          add_account: "Add Accounts",
          add_teacher: "Add Teachers",
        },
        circle_2: {
          add_grade: "Years and Classes",
          describe_grade: "Add years and classes",
        },
        circle_3: {
          add_asssign: "Assign",
          describe_assign: "Assign teachers to classes",
        },
        circle_4: {
          review: "Review",
        },
      },
      step_0: {
        title: "Admin",
        subtitle:
          "Manage your team members and their account permissions here.",
        school_structure: "Setup your school structure",
        tell_us: "Tell us about your school structure below.",
        btn_start: "Get Started",
      },
      step_1: {
        title: "Add Teachers",
        subtitle:
          "Add your teachers to the system so that they can manage their classes and students.",
        name: "Name",
        mr: "Mr.",
        ms: "Ms.",
        mrs: "Mrs.",
        dr: "Dr.",
        surname: "Surname",
        position: "Position",
        email: "Email",
        phone_number: "Phone number",
        sa: "SA",
        btn_add: "Add another",
        btn_add_a_teacher: "Add a Teacher",
        email_exists: "Email already exists!",
        delete_teacher_confirm: "Please confirm that you would like to delete this class group teacher.",
        invalid_email: "Please enter a valid email address",
      },
      step_2: {
        title: "What years that will be using Reflective Learning?",
        grade: "Year",
        subject: "Which subjects will they be using on Reflective Learning?",
        english: "English",
        maths: "Maths",
        validation: {
          language: "One or more classes are missing a preferred language.",
          className: "One or more classes are missing a class name.",
          subject: "One or more classes are missing a selected subject.",
          grade: "One or more selected grades have no assigned classes."
        }
      },
      step_3: {
        grade: "Year",
        english: "English",
        subject:
          "Which subjects will they be using on <br/> Reflective Learning?",
        select_teacher: "Select Teacher",
        maths: "Maths",
        assign_teacher: "Assign Teachers",
        btn_review: "Next: Review Setup",
      },
      step_4: {
        classes: "Classes",
        send_login: "Send login details",
        send_details:
          "Send details to the teachers that you've added to this system for them to complete their registration.",
        btn_send: "Send logins",
        send_login_no_teachers: "Complete process",
        send_details_no_teachers: "No teachers have been added, this can be done later through the admin page. Continue to finish the school setup.",
        btn_send_no_teachers: "Continue",
        success: "Success",
        success_message: "Login details successfully sent to all teachers",
        btn_done: "Done",
        btn_confirm: "Confirm information",
        btn_view: "View Dashboard",
        not_yet: "Not ready yet?",
        review_teachers: "Review Teachers and Classes",
        edit: "Edit Teachers and Classes",
        sending: "Sending...",
        btn_save: "Save my Progress",
      },
    },
    loaders: {
      admin_store: {
        creatingAdmin: "Creating a new admin...",
        updatingAdmin: "Updating an admin...",
        fetchingAllAdmins: "Fetching all admins...",
        fetchingSingleAdmin: "Fetching a single admin...",
        deleteAdmin: "Deleting an admin...",
      },
      learner_store: {
        fetchSchoolLearners: "Fetching learners...",
        createLearner: "Creating learner...",
        updateLearner: "Updating...",
        bulkCreateLearners: "Creating learners...",
        bulkArchiveLearners: "Archiving learners...",
        validateEmail: "Validating email...",
      },
      license_store: {
        fetching_Licenses: "Fetching Licenses",
        request_seats: "Requesting more seats",
        creating_license: "Creating a new license",
        updating: "Updating..."
      },
    },
    activity_view: {
      header: "Activity",
      all: "All",
      cards: {
        active_last_7_days: "active in the last 7 days",
        average_time: "average active time",
        time_learning: "of time spent learning",
        total_active_users: "total active users",
        on_track: "on track with tasks",
      },
      activity_summary_per_class_card: {
        header: "Activity Summary per Class",
        subheader: "Keep track of vendor and their security ratings",
        classes: "Classes",
        last_30_days: "Last 30 days",
        last_7_days: "Last 7 days",
        vendor: "Vendor",
        class: "Class",
        average_minutes: "Average Minutes",
        daily_tasks: "Daily Tasks",
        min: "min",
        page: "Page",
        of: "of",
        previous: "Previous",
        next: "Next",
      },
      metting_engagement_requirement_card: {
        header: "Meeting engagement requirements",
        subheader: "% of students with at least 30 minutes of activity",
        month: "June",
      },
      activity_summary_per_student_card: {
        header: "Activity Summary per Student",
        subheader: "Keep track of vendor and their security ratings",
        student: "Student",
      },
      login_task_completion_card: {
        header: "Login vs Task Completion",
        subheader: "in the last 30 days",
      },
      tooltips: {
        active_last_7_days: "Active in the last 7 days",
        average_time: "Average active time",
        time_learning: "of time spent learning",
        total_active_users: "Total active users",
        on_track: "On track with tasks",
        activity_summary_student: "Activity Summary per Student",
        activity_summary_class:
          "A class breakdown of the average active minutes per student, and the percentage of students who completed their assigned tasks",
        meeting_engagement_requirements:
          "Percentage of students who met the minimum engagement expectations per week, for the last 4 weeks",
        login_vs_task_completion: "Login vs Task Completion",
        current_mastery:
          "Baseline and current level of mastery per journey (darker shades show improvement)",
        concept_mastery:
          "Baseline and current level of mastery per journey (darker shades show improvement)",
        class_activity_30_days: "The total learning time for the 30 days per active student.",
        class_activity_7_days: "The total learning time for the week per active student.",
        student_activity_30_days: "The total learning time for the 30 days per active day.",
        student_activity_7_days: "The total learning time for the week per day.",
      },
    },
    overview_page: {
      rollover_view: {
        header: "Let's get started",
        subheader: "Your classes are currently empty",
        add_students: "Add Students",
        students: "Students",
        all_learners_assigned_in_grade: "All learners assigned in year",
        all_teacher_classes_have_at_least_one_student: "All your classes have at least one student. Please wait for your school admin to complete rollover.",
        table_component: {
          header: "Add students to class",
          class: "Class",
          last_name: "Last name",
          first_name: "First name",
          email: "Email",
          previous_class: "Previous Class",
          grade: "Year",
          back: "Back",
          submit: "Submit",
          previous_class_label: "Filter by Previous Class",
          all_classes_text: "All Classes",
          confirm_modal: {
            header: "Confirm your selection",
            selected_text: "You've selected",
            text: "students assigned to",
            edit: "Edit",
            correct: "Yes, that's correct",
          },
        },
      },
      header: "My Classes",
      active: "active",
      average_gaps: "Avg. gaps per student",
      gaps_per_student: "Gaps per students",
      active_last_7_days: "Active in the last 7 days",
      student_active: "Students active",
      active_time: "Avg. time on app per student",
      min: "min",
      per_week: "per week",
      time_spent_learning: "Avg. time spent learning",
      daily_tasks: "Task Completion",
      students: "Students",
      most_active_class: "Class Activity",
      this_week: "Last 30 Days",
      most_active: "Most Active",
      least_active: "Least Active",
      students_active: "students",
      minutes_average: "min. average",
      at_glence: "Students on track",
      on_track: "On Track",
      falling_behind: "Falling behind",
      ahead: "Ahead",
      announcements: "Announcements",
      reflection_questions: "Reflection Question Performance",
      numbers: "Numbers",
      fractions: "Fractions",
      measurements: "Measurements",
      data_literacy: "Data Literacy",
      problem_solving: "Problem Solving",
      patterns: "Patterns & Algebra",
      space: "Space & Shape",
      visual: "Visual Communication",
      oral: "Oral Comprehension",
      written: "Written Comprehension",
      language: "Language Structure",
      tasks_completed: "Learners who have completed the tasks",
      tooltips: {
        avg_gaps: "Avg. gaps per student",
        active_last:
          "Percentage of students who have logged in in the last 7 days",
        active_time:
          "The average amount of time that each active student is engaging in with learning in the past 7 days",
        time_learning:
          "Percentage of total active time that is spent learning (eg. assessments, catch up lessons, practice, etc)",
        reflection_question: "Reflection Question Performance",
        daily_task:
          "The number of students, per week, who have completed their assigned tasks",
        class_activity: "Class Activity",
        at_a_glance:
          "A breakdown of how students are tracking against their expected daily task completion to date",
      },
    },
    journeys_view: {
      journeys: "Journeys",
      students_at_expected_level: "Students at Expected Level",
      students: "students",
      current_mastery: "Current Mastery",
      baseline_completion: "Baseline Completion",
      incomplete: "incomplete",
    },
    concepts_view: {
      header: "Concepts",
      baseline_incomplete: "of students have not completed the baseline assessment",
      to_be_assessed: "students to be assessed",
      proficiency_by_concept: "Proficiency by concept",
      mastery_at_required_level: "Mastery at required level",
      no_data: "No data for the current filter",
      tooltips: {
        proficiency_by_concept:
          "How assessed students are spread across all four proficiency levels for each concept in the selected journey. The top level, shown in dark green, is 'At Expected'.",
        mastery_toggle:
          "Average across this journey's concepts of the percentage of assessed students at the Expected level. 'Start' uses each student's first attempt and 'Current' uses their most recent attempt. Students who have not been assessed yet are not counted, so this is a share of assessed students, not of the whole class.",
        mastery_at_required_level:
          "For each concept, the percentage of assessed students who have reached the Expected level, the top level. Students who have not been assessed yet are excluded.",
      },
      toggle: {
        start: "Start",
        current: "Current",
      },
      table: {
        concept: "Concept",
        start: "Start",
        current: "Current",
      },
      modal: {
        no_description: "No description available for this concept yet.",
        students_at_level: "Students at this level",
        no_students: "No students at this level.",
        cancel: "Cancel",
        confirm: "Confirm",
      },
    },
    overview_modal: {
      past_month: "The past Month",
      weekly_active: "Weekly active time",
      min: "min",
      time_spent: "Time spent learning",
      daily_tasks: "Daily tasks complete",
      level: "Level",
      incomplete: "Incomplete",
      baseline: "Baseline",
      latest: "Latest",
      grade_level_mastered: "Year level mastered",
      individual_students: "Individual students",
      expected_level: "Expected Level",
      levels_achieved: "Levels Achieved",
      current_mastery: "Current Mastery",
    },
    journey_modal: {
      current_mastery: "Current Mastery",
      select_journey: "Select a Journey on the left to view details",
      concepts_mastered: "Concepts Mastered",
      gaps_remaining: "Gaps Remaining",
      current_trophy: "Current Trophy",
      mastery: "Mastery",
      mastered: "Mastered",
      not_mastered: "Not Mastered",
      level: "Level",
      language_structure_mastery:
        "Detailed look at the journey mastery, including gaps, trophy achieved, and individual concept mastery breakdown",
    },
    update_student: {
      title: "Edit Student",
      personal: {
        personal: "Personal",
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        password: "Password",
        student_number: "Student number",
        message: "Must be at least 6 characters",
        email_exists: "Email already exists.",
        email_invalid: "Email is invalid.",
      },
      settings: {
        settings: "Settings",
        grade: "Year",
        locked_journeys: "Locked journeys",
        country: "Country",
        catchup: "Catchup",
        assessment: "Assessment",
        none: "None",
        status: "Status",
      },
      subject: {
        subject: "Subject",
        class: "Class",
        assessment_level: "Assessment level",
        assessment_level_validation: " Only one level change is allowed.",
        language: "Language of learning",
      },
    },
    journey_view: {
      header: "Journey",
      tooltips: {
        student_at_expected_level:
          "Percentage (and count) of students who have fully mastered each journey at the level expected of them",
        current_mastery:
          "The baseline and current level of mastery per student per journey (darker shades show improvement)",
        baseline_completion: "Baseline completion",
      },
    },
    reports_view: {
      header: "Reports",
      modal: {
        title: "Preparing Report",
        message:
          "We are preparing your report currently. It will be emailed to you in the next 5 - 10 mins. If you do not receive it, please contact {email}",
        button: "Go back to dashboard",
        date_range: "Confirm Download Date Range:",
        download_btn: "Download Report"
      },
      reports: {
        "ready-for-reassessment": {
          name: "Ready for a reassessment",
          subTitle: "Per students",
        },
        "current-levels-achieved": {
          name: "Current levels achieved",
          subTitle: "List of students",
        },
        "incomplete-baseline-assessments": {
          name: "Incomplete baseline assessments",
          subTitle: "Per students",
        },
        "concept-mastery-achieved-per-student": {
          name: "Concept mastery achieved per student",
          subTitle: "A detailed breakdown",
        },
        "summary-of-concept-mastery": {
          name: "Summary of concept mastery",
          subTitle: "Baseline & Current",
        },
        "detailed-activity-for-last-7-days": {
          name: "Detailed activity for last 7 days",
          subTitle: "Minutes per student",
        },
        "detailed-activity-for-last-30-days": {
          name: "Detailed activity for last 30 days",
          subTitle: "Minutes per student",
        },
        "detailed-activity-for-last-90-days": {
          name: "Detailed activity for last 90 days",
          subTitle: "Minutes per student",
        },
        "inactive-for-7-days": {
          name: "Inactive for 7 days",
          subTitle: "List of students",
        },
        "inactive-for-30-days": {
          name: "Inactive for 30 days",
          subTitle: "List of students",
        },
        "inactive-for-90-days": {
          name: "Inactive for 90 days",
          subTitle: "List of students",
        },
        "pdf-bulk-download": {
          title: "Learner PDF Reports",
          name: "Bulk Download",
          subtitle: "Download link will be emailed to you.",
        },
        "graduates": {
          name: "Graduates",
          subtitle: "Students with 100% concept mastery for an assessment.",
        },
        "high-engagement": {
          name: "Student Engagement",
          subtitle: "Students with the highest engagement.",
        },
        "continued-improvement": {
          name: "Continued Improvement",
          subtitle: "Students with the highest improvement.",
        }
      },
    },
    admin_overview_component: {
      activity_by: "Activity By Class",
      class: "Class",
      last_login: "Last Login <br />(on dashboard)",
      average_min: "Average Min. <br />(Goal: 30 min)",
      daily_tasks: "Daily Tasks <br />(Goal: 80%)",
      days_ago: "days ago",
      licenses_used: "Licenses used",
      explore_premium: "Explore premium",
      btn_add: "Add Licenses",
      noticeboard: "Noticeboard",
      sec: "sec",
      hr: "hr",
      min: "min",
      license_modal: {
        request_license: "Request License",
        license_requried: "Additional licenses requeire admin approval",
        used: "licenses used",
        grade: "Year",
        licenses: "licenses",
        how_many: "How many additional licenses would you like to request?",
        chat_to_us: "Chat to us",
        btn_cancel: "Cancel",
        submit: "Submit Request",
      },
    },
    profile_view: {
      title: "My Profile",
      personal_info: "Personal Info",
      update_details: "Update your photo and personal details here.",
      name: "Name",
      name_placeholder: "Your First Name",
      surname_placeholder: "Your Surname",
      email: "Email address",
      email_placeholder: "Email Address",
      photo: "Your Photo",
      your_profile: "This will be displayed on your profile",
      profile_alt: "Profile Picture",
      btn_delete: "Delete",
      btn_update: "Update",
      btn_cancel: "Cancel",
      designation: "Designation",
      designation_placeholder: "My Role",
      instagram: "Instagram",
      instagram_placeholder: "Instagram",
      linkedIn: "LinkedIn",
      linkedIn_placeholder: "Linkedin",
      updating: "Updating",
      save: "save",
      settings: "Settings",
      update_account: "Update Account Settings",
      password: "Password",
      input: {
        required: "This field is required",
        length: "Should be more than 6 characters",
        profile_alt: "Profile Picture",
      },
      change_password: "Change Password",
      current_password: "Current Password",
      new_password: "New Password",
      confirm_new_password: "Confirm New Password",
      updating_password: "Updating Password",
      update_password: "Update Password",
      confirm_password: "New password and confirm password do not match.",
      no_user: "No user is signed in.",
      incorrect_password: "Current password is incorrect.",
      weak_password: "New password is too weak.",
      failed_update: "Failed to update password.",
    },
    admin_view: {
      header: "Admin",
      tooltips: {
        activity_by_class_card: "User activity summary per class.",
        licenses_card: "School Licenses usage.",
        noticeboard_card: "Notices and Announcements",
      },
      modals: {
        complete_class_review: {
          class_structure: "Class structure complete",
          final_step: "The final step is just around the corner.",
          soon_get_emails:
            "Teachers will soon receive an email that will guide them in assigning [students] to their new classes.",
          btn_confirm: "Confirm & Close",
          not_ready: "Not ready yet?",
          come_back: "Come back later",
        },
        goto_assign: {
          almost: "Almost there!",
          final_step: "The final step is just around the corner.",
          number_students:
            "[Students] need to be assigned to their new classes.",
          assign: "Assign [students]",
          not_ready: "Not ready yet?",
          come_back: "Come back later",
        },
      },
    },
    modals: {
      teacher_class_permission: {
        title: "Action Not Allowed",
        description:
          "You do not have the necessary permissions to perform this action. Please contact your administrator if you believe this is an error.",
        btns: {
          ok: "OK",
        },
      },
      teacher_add_learners_prompt: {
        title: "Upload Learners",
        description:
          "There are no learners in this class group. Would you like to upload learners now?",
        btns: {
          cancel: "Cancel",
          ok: "OK",
        },
      },
    },
    rollover: {
      incomplete_view_screen: {
        back: "Back",
        previous: "Previous Year",
        confirm_review_next_grade: "Confirm and review next year",
        confirm_rollover: "Confirm & rollover",
        students: "students",
      },
      learner_rollover_table_screen: {
        grade: "year",
        students_selected: "students selected",
        classes: "Classes",
        all: "All",
        info_text_one:
          "Please indicate whether any students will repeat the year or leave the school, requiring their accounts to be closed",
        info_text_two:
          "Students without any selected options will be automatically moved to the next year",
        table: {
          first_name: "First name",
          last_name: "Last name",
          email: "Email",
          class: "Class",
          repeat: "Repeat",
          remove: "Remove",
        },
        upload_button: "Upload",
        upload_title: "Upload learners",
        upload_description: "Are you sure you want to upload a new list of learners? This will overwrite the current selections.",
        upload_template: "Click here to download the template.",
        upload_confirm: "Confirm",
        upload_cancel: "Cancel",
      },
      review_class_structure_screen: {
        title: "Review class structures",
        sub_title:
          "Let's make sure all classes have the correct teachers assigned to them for these years",
        grade: "Year",
        students: "students",
        view: "View",
        back: "Back",
        confirm_email_teachers: "Confirm & email teachers",
        table_content: {
          title: "Which subjects will they be using on Reflective Learning",
          grade: "Year",
          assigned_teachers: "Assigned teachers",
          language: "Language of learning",
          marked_for_deletion: "This class is marked for deletion",
          new_teacher_tooltip:
            "This will be the new teacher. Current Teacher is",
          unmark_class_tooltip: "Unmark this class for deletion",
          new_class_added_tooltip: "This is a new class to be added",
          add_class: "Add Class",
          cancel: "Cancel",
          save: "Save changes",
          update_success: "Successfully updated",
        },
      },
      modal: {
        confirm_date: {
          title: "We're moving all students to the next",
          starting: "starting",
          text: "Please review and confirm these changes",
          change: "Change",
          date_correct: "Date is correct",
          not_ready: "Not ready yet",
          confirm_later: "Confirm later",
          cancel: "Cancel",
          confirm_dates: "Confirm dates",
        },
        success: {
          title: "Rollover Complete",
          text: "Learners have now been assigned to their new classes. You should have received an email with the details.",
          confirm: "Confirm",
        },
        incomplete_view: {
          confirm_selection: "Confirm your selection",
          you_selected: "You've selected",
          students_to_move: "students to move to the next year",
          students_to_remain: "students to remain in the same year",
          students_to_remove: "students to be removed from the system",
          edit: "Edit",
          correct: "Yes, that's correct",
          review_structure: "Review class structure",
          review_text:
            "This is to ensure that classes are assigned to the correct teachers after they’ve been moved up a year",
          do_later: "Do it later",
          review_now: "Review now",
        },
        review_class_structure: {
          class_structure_complete: "Class structure complete",
          final_step_text: "The final step is just around the corner",
          teacher_emails_text:
            "Teachers will soon receive an email that will guide them in assigning [students] to their new classes",
          confirm: "Confirm & Close",
          not_ready: "Not ready yet",
          back_later: "Come back later",
          almost_there: "Almost there",
          student_assigned_text:
            "[Students] need to be assigned to their new classes",
          assign: "Assign [students]",
          cant_do_header: "Yikes! Can’t do that",
          cant_do_subheader:
            "We can’t delete a class with students in it. First move students to another class, or remove them, before deleting the class",
          cant_do_btn: "Go back",
        },
      },
    },
    internal_tools: {
      school_champions: {
        modal: {
          confirm_title: "Confirmation required",
          confirm_text: "Please confirm that you would like to delete this school champion",
          back: "Back",
          confirm_btn: "Confirm deletion"
        }
      },
      top_bar_heading: {
        create: "Create School Group and school",
        add: "Add School",
        edit: "Edit school details",
        track: "Track",
        push: "Push",
        archive: "Archive",
        activitylogs: "Activity Logs",
        internaladmins: "Internal Admins",
        regionmoves: "Move schools between regions"
      },
      top_bar: {
        create: "Create",
        add: "Add",
        edit: "Edit",
        track: "Track",
        push: "Push",
        archive: "Archive",
        activitylogs: "Activity Logs",
        internaladmins: "Internal Admins",
        regionmoves: "Region Moves"
      },
      edit_school: "Edit school details",
      region_guard: {
        message: "Schools in this country are created in the {belongs} region, and you are signed in to {here}. Switch region and create the school there.",
        switch: "Switch region"
      },
      panel: {
        school_details: "School details",
        class_details: "Class details",
        teacher_details: "Teacher details",
      },
      form: {
        school_location: "School location",
        domain_name: "Domain name",
        city: "City",
        city_name: "City name",
        country: "Select a country",
        country_title: "Country",
        language_title: "Language",
        language: "Choose a language",
        subscription_dates: "Subscription dates",
        learning_mode: "Learning mode",
        start_date: "Start date - Expiry date",
        grade_naming: "Grade naming convention",
        english_licenses: "English Licenses",
        maths_licenses: "Maths Licenses",
        license_type: "License type",
        emis_number: "EMIS number",
        start_month: "Month of academic year start (MM-DD)",
        month: "Month",
        end_month: "Month of academic year end (MM-DD)",
        add_champion: "Add Champion Details",
        assign_champion: "Assign Existing Champion",
        champion_name: "Name",
        champion_surname: "Surname",
        champion_email: "Email",
        champion_title: "Title",
        champion_phone: "Contact number",
        btnSaving: "Saving Changes..",
        btnSave: "Save Changes",
        school_name: "School name",
        add_existing_champion: "Add Existing Champion",
        select_champion: "Select Champion",
        add_existing_instructions: "Select an existing admin from another school belonging to this school group.",
        subject: "Subject",
        select_subject: "Select subject"
      },
      success: {
        btnClose: "Dismiss",
        school_message: "School details have been updated successfully",
        champions_message: "Champion(s) have been added successfully",
        school_group_update: "School group updated successfully"
      },
      select: "Select a country",
      add_school: {
        school_location: "School location is required.",
        domain_name:
          "Domain name is required. Students without email addresses will be created using this domain.",
        domain_example:
          "Domain name needs to be in a format like schoolname.com",
        city_name: "City is required.",
        couunty_name: "Country is required.",
        language: "Language is required.",
        school_name: "School name is required.",
        start_date: "Month of academic year start is required.",
        end_date: "Month of academic year end is required.",
        school_message: "School was successfully created",
        create_school: "Creating School...",
        champion_message: "{schoolAdminMessage} school champion(s) created",
        school_group_champion_message: "{adminMessage} school group champion(s) created",
        school_group_only: "Only the school group was created without any school(s)!",
        subject: "At least one subject is required.",
      },
      rollover_alert_compoent: {
        btn_start: "Start The Rollover Process",
        grade_title:
          "Year {grade} Transition Alert: Start The Rollover Process",
        grade_sub_title:
          "We're moving students up a Year. Please ensure that this process has been completed for a seamless transition.",
        btnContinue: "Continue Learner Rollover Review",
        learner_text: "Learner Rollover Details: Action Required",
        please_review:
          "Please review and confirm the learners’ rollover details to continue.",
        btn_start_class: "Start Class Review",
        class_review: "Class Review: Pending Confirmation",
        learner_rollover_confirm:
          "Learner rollover confirmed. Please review and confirm class structures.",
        continue_class_review: "Continue Class Review",
        class_review_in: "Class Review: In Progress",
        class_review_details:
          "Class review details are currently being confirmed.",
        start_class_review: "Start Class Review",
        rollover_to_be: "Awaiting Rollover to be complete on {date}",
        all_details:
          "All details confirmed. Awaiting rollover execution on the scheduled date. You will receive an email once the rollover is complete.",
        assign_learners: "Assign Learners",
        learners_to_class: "Assign Learners to Classes",
        rollover_class_review:
          "Rollover and class review complete. Please assign learners to their new classes.",
        finish_assign: "Finish Assigning Learners",
        learner_assignment_pending_button: "Execute Learner Assignment",
        learner_assignment_pending_title: "Learner assignment pending",
        learner_assignment_pending_subtitle: "Learners have been allocated to classes and are pending execution.",
        learners_assign_in_progress: "Learner Assignment: In Progress",
        learners_assigning: "Learners are being assigned to classes.",
        rollover_complet: "Rollover Complete",
        all_steps:
          "All steps completed successfully. Teachers can now log in to see their classes.",
        error_unknown_state: "Error: Unknown State",
        unknown_state: "unknown",
        unknown_text: "The current state of the rollover process is unknown.",
      },
      school_group:  {
        title: "What would you like to create?",
        sub_title: "Select an option below to get started",
        btn_single: "Individual schools",
        btn_multiple: "Group of schools",
        btn_back: "Back",
        btn_next: "Next Step",
        group_name: "Group name",
        group_description: "Group description",
        type_here: "Type here",
        group_name_validation: "Group name is required.",
        group_description_validation: "Group description is required.",
        group_details: "Group Details",
        confirm_text: "Please confirm that you would like to delete this school group champion",
      },
      single_school_component: {
        title: "Add School Group Champion Details", 
        failed_school_group: "Failed to create school group.",
        faliled_school: "Failed to create school.",
        error_message: "An error occurred during the process. Please try again."
      },
      multiple_schools_component: {
        no_champion: "No champion",
        schools: "New Schools",
        add_school: "Add School",
        update_school: "Update School",
        create_school: "Creating Schools...",
        school_group_not_created: "School Group was not successfully created",
        school_group_created: "School Group <b>{groupName}</b> was successfully created.",
        schools_created: "<b>{totalSchools}</b> school{plural} {verb} successfully created.",
        plural: "s",
        was: "was",
        were: "were",
        error_message: "An error occurred while creating the schools.",
        delete_message: "Are you sure you want to delete school?",
        btn_cancel: "Cancel",
        btn_delete: "Delete",
        create_license: "Create a license for the school"
      },
      edit_selection_component: {
        title: "What would you like to edit?",
        subtitle: "Select an option below to get started",
        school_details: "Edit school details",
        edit_school_group: " Edit School Group Details",
      },
      archive_selection_component: {
        title: "What would you like to archive/unarchive?",
        subtitle: "Select an option below to get started",
        archive_school_groups: "Archive School Group",
        unarchive_school_groups: "Unarchive School Group",
        archive_schools: "Archive School",
        unarchive_schools: "Unarchive School",
        archive_learners: "Archive Learners",
        unarchive_learners: "Unarchive Learners",
      }
    },
  },
  "lingo_v2": {
    "grammar": {
      "level_1_description": "<p>Students demonstrate awareness of basic word classes, including nouns, verbs, adjectives, and pronouns, and apply these in simple sentences. Regular pluralisation patterns are used, with emerging control of possessives, articles, and basic prepositions such as in, on, and under. Compound words and the prefix un– are applied to show early morphological awareness.</p><p>Verbs are recognised as doing or being words, with accurate use of simple present and past tense. Short noun and verb phrases are constructed, with subject–verb agreement maintained in simple sentences. Coordinating words such as and or because are used to link ideas, and suffixes such as –ing and –ed signal tense.</p><p>Punctuation and capitalisation are applied consistently in basic contexts. Sentences begin with capital letters, proper nouns are recognised, and full stops, question marks, and exclamation marks are used accurately. Apostrophes are introduced for contractions and simple possession, and commas appear in short lists.</p>",
      "level_2_description": "<p>Students apply pluralisation accurately, including irregular forms, and demonstrate control of possessive nouns and pronouns. Determiners are selected appropriately, and reflexive pronouns are used alongside subject and object forms. Vocabulary is expanded through affixes such as re–, dis–, –ful, –ly, and –less, supporting awareness of word families.</p><p>Verb knowledge extends to continuous forms using to be and to have, alongside irregular past tense and simple future marked with will. Compound sentences are formed reliably using conjunctions such as and, but, and because, with logical sequencing maintained. Errors involving double negatives are avoided, and subject–verb agreement is sustained in extended contexts.</p><p>Punctuation is accurate for statements, questions, and exclamations, with capitalisation applied to names, places, and calendar terms. Apostrophes are used for contractions and possession, and commas are applied in longer lists or between clauses in compound sentences.</p>",
      "level_3_description": "<p>Students distinguish between collective, concrete, and abstract nouns, apply irregular plurals, and use possessive forms with accuracy. Homophone distinctions such as there/their, its/it’s, and than/then are controlled. Adjectives and adverbs are applied deliberately, with correct ordering of multiple adjectives and use of adverbial phrases.</p><p>Sentence variety includes both compound and emerging complex forms. Main and subordinate clauses are distinguished, and expanded noun phrases and adverbial clauses are used to add detail. Errors such as run-ons, comma splices, and double negatives are identified and corrected.</p><p>Verb use includes the present perfect alongside simple past, with auxiliary verbs handled accurately. Subject–verb agreement is maintained, and irregular forms are applied correctly. Punctuation extends to commas for separating clauses, quotation marks for direct speech, and consistent use of apostrophes for contractions and possession.</p>",
      "level_4_description": "<p>Students apply nouns accurately across common, proper, and abstract categories, including invariable forms and plural possessives. Homophones such as your/you’re, to/too, and then/than are distinguished with reliability. Pronoun–antecedent agreement is maintained, and adjectives and adverbs are used with precision in comparative, superlative, and modifying roles.</p><p>Complex sentences are constructed through relative clauses, embedded clauses, and a range of subordinating conjunctions. Clause function—subject, object, adverbial, and complement—is recognised and applied effectively. Sentence errors such as misplaced modifiers and run-ons are corrected, and coordination and subordination are managed fluently.</p><p>Verb use extends to past perfect, future continuous, and introductory passive forms. Conditional sentences are constructed appropriately, and subject–verb agreement is consistent within complex contexts. Punctuation includes commas for clauses and introductory phrases, apostrophes for plural possession, and quotation marks for speech.</p>",
      "level_5_description": "<p>Students demonstrate accuracy with irregular plurals, possessives, and distinctions among commonly confused homophones. Articles are chosen correctly, and pronoun use expands to interrogative and indefinite forms with consistent agreement. Adjectives and adverbs are precise and varied, while prepositions extend meaning within and across sentences.</p><p>Sentence variety includes relative and adverbial clauses, reduced relatives, and prepositional phrases that expand expression. Complex and compound–complex sentences are composed with logical sequencing, while errors such as double negatives are avoided. Coordinating, subordinating, and correlative conjunctions are used flexibly, and adverb placement strengthens clarity.</p><p>Verb use includes modal verbs expressing possibility, necessity, and certainty, alongside extended use of the passive voice. The future perfect tense is introduced and subject–verb agreement remains accurate. Punctuation incorporates colons, semicolons, parentheses, and commas before conjunctions, with apostrophes distinguishing clearly between plural and possessive forms.</p>",
      "level_6_description": "<p>Students demonstrate control of irregular and classical plural forms, alongside complex determiners such as quantifiers and distributives. Homophones and commonly confused words such as whose/who’s, affect/effect, fewer/less, and lie/lay are distinguished accurately. Pronouns are applied across all major categories, with agreement sustained consistently in extended texts.</p><p>Sentence structures include compound–complex forms, multiple subordinate clauses, and accurate use of restrictive and non-restrictive clauses. Participle and non-finite clauses extend expression, and conjunctive adverbs such as however and therefore enhance logical links. Parallel structure and comparisons are maintained, and sentence errors such as fragments and dangling modifiers are avoided.</p><p>Verb use demonstrates control of all tense forms, including perfect progressive and advanced conditionals. Passive voice is applied purposefully across tenses, and modal verbs are chosen for register and tone. Punctuation incorporates ellipses, hyphenation, and refined use of quotation marks, with capitalisation extending to proper adjectives.</p>",
      "level_7_description": "<p>Students demonstrate advanced control of all word classes, with accuracy across irregular, abstract, and collective forms. Morphological knowledge supports precise interpretation of meaning through prefixes, suffixes, and roots. Homophone and word-pair distinctions such as affect/effect, fewer/less, amount/number, and between/among are mastered, and modifiers, determiners, and pronouns are applied consistently in extended contexts.</p><p>Clause variety is integrated with fluency, including relative, adverbial, non-finite, and participle clauses placed for stylistic effect. Compound–complex sentences show accuracy and cohesion, with logical relationships expressed through conjunctions and conjunctive adverbs. Sentence rhythm and emphasis are achieved through deliberate manipulation of clause order and structure, while common errors are eliminated.</p><p>Verb use covers all tense and aspect combinations, with conditional and passive forms applied confidently across contexts. Modal verbs are employed with nuance to convey shades of meaning, and subject–verb agreement is sustained even in extended writing. Punctuation demonstrates mastery of advanced devices, including semicolons, colons, dashes, and parentheses, alongside precise handling of quotation, ellipsis, and hyphenation.</p>"
    },
    "spelling": {
      "level_1_description": "<p>Spelling demonstrates accuracy with short, regular words following consonant–vowel–consonant patterns, alongside the first set of high-frequency items. Knowledge of one-to-one sound–letter correspondences is secure, allowing students to represent most sounds consistently. Familiar sight words such as the, and, was are recognised and applied with accuracy in short sentences.</p><p>Control begins to extend to digraphs such as sh, ch, th, though these may not yet be reliable. Spelling of less familiar words is often phonetic, reflecting reliance on segmenting and blending, but approximations are recognisable and increasingly close to target forms. Attempts show developing control of word boundaries and simple morphemic patterns.</p><p>Errors are predictable and reflect immature strategies, while correct spellings are limited to the most familiar vocabulary. Functional writing communicates meaning clearly with words such as cat, dog, sun, bed, supported by a restricted but dependable spelling base.</p>",
      "level_2_description": "<p>Spelling includes accuracy with consonant blends such as br, cl, st and common digraphs such as wh, ng, th. Regular long-vowel patterns (ai, ee, oa) are applied with growing consistency, and sight words are recalled more fluently. Familiar irregular words such as said or was appear correctly spelled in extended contexts.</p><p>Inflectional endings are managed with control, including –s, –es, and –ed, with plurals handled reliably. Words show evidence of applying rules for endings such as changing y to ies. Invented spellings demonstrate partial but logical application of phonics and morphology.</p><p>Errors are generally confined to less common vowel patterns or unfamiliar longer words. Mastery is evident in items such as rain, boat, tree, black, jump, together with reliable accuracy in functional classroom writing.</p>",
      "level_3_description": "<p>Spelling demonstrates confidence with high-frequency words and regular morphemic patterns. Prefixes such as un–, re– and suffixes such as –ing, –ful, –ness are applied consistently to generate new words. Families such as happy, unhappy, happiness show awareness of meaning and form.</p><p>Control extends to r-controlled vowels (car, bird, turn) and irregular vowel spellings, including challenging forms such as ough. Multisyllabic words are attempted by breaking them into syllables, with most produced recognisably and increasingly accurately.</p><p>Errors shift from phonetic approximations toward irregular forms and unusual word families.</p><p>Representative words at this level include quickly, said, does, alongside accurate spelling of common morphological combinations.</p>",
      "level_4_description": "<p>Spelling accuracy extends to multisyllabic words, silent letters, and homophone pairs. Irregular words such as knight, island, and yacht are handled with increasing confidence. Academic vocabulary drawing on Latin or Greek origins, such as phone or graph, is spelled with accuracy.</p><p>Knowledge of morphemes supports precision across word families. For example, understanding aqua enables reliable spelling of aquarium or aquatic. Segmenting words into meaningful parts allows application of spelling knowledge beyond the most common forms. Representative words include temperature, ecosystem, their/there/they’re, showing control of both subject-based and functional vocabulary. Accuracy at this stage reflects fluency with common and less predictable structures.</p>",
      "level_5_description": "<p>Spelling demonstrates control of irregular forms, advanced affixes, and subject-specific vocabulary. Endings such as –tion, –sion, –cian are applied consistently, alongside irregular plurals. Complex words are managed reliably across a range of contexts.</p><p>Etymological knowledge supports spelling choices, particularly for loanwords from French, Latin, and Greek. Understanding of root words contributes to accuracy in formal and academic vocabulary. Representative examples include ballet, chaos, chorus, and civilisation.</p><p>Errors are largely confined to very low-frequency loanwords. Accuracy extends across longer texts, supporting clear communication in both subject-specific and general writing.</p>",
      "level_6_description": "<p>Spelling accuracy is consistent in extended writing across genres, including technical, academic, and creative contexts. Morphological contrasts such as –ible/–able and –ance/–ence are applied with confidence, demonstrating flexible word knowledge.</p><p>Loanwords and advanced subject terms are handled correctly in most contexts, reflecting integration of phonological, morphological, and etymological strategies. Errors are infrequent and usually occur only with unfamiliar or highly irregular words.</p><p>Representative items include photosynthesis, parliament, achievable, perseverance, and equation. At this stage, spelling supports fluent composition without hindering clarity or precision.</p>",
      "level_7_description": "<p>Spelling competence extends to advanced and discipline-specific vocabulary, including low-frequency and technical terms. Words of Greek, Latin, and other origins are spelled reliably, regardless of irregularity or exception to rule.</p><p>Awareness of regional conventions such as British and American spelling allows adaptation to audience and context. Accuracy is expected at all times, with errors confined to rare or specialist terms.</p><p>Representative examples include metamorphosis, jurisprudence, synchronisation, chlorophyll, and aesthetic. Spelling at this level demonstrates mastery and readiness for advanced academic or professional contexts.</p>"
    },
    "tooltips": {
      "kc_status": {
        "seen": "At least one question answered",
        "learning": "At least two errors",
        "reinforcing": "Completed blocked practice or teacher intervention. If two more errors are made after this, back to ‘Learning’",
        "not_yet_seen": "No questions answered yet",
        "mastered_new_learning": "At least two errors early on, but now with three correct in a row",
        "mastered_prior_learning": "The first two questions correct; or a single error followed immediately by three correct in a row"
      },
      "kc_arch_progress_status": {
        "seen": "Items on the list which have at least one question answered.",
        "learning": "Items on the list where at least two errors were made.",
        "mastered": "Items on the list which had the first two questions in a row answered correctly, or have had three in a row correct at any time.",
        "reinforcing": "Items on the list which were focussed on recently by the teacher, or by a ‘blocked activity’.",
        "not_yet_seen": "Items on the list which haven’t had any questions yet."
      }
    },
    "vocabulary": {
      "level_1_description": "<p>Vocabulary consists of familiar, concrete words tied to home, school, and play. High-frequency function words are recognised and used in short sentences to support basic communication.</p><p>Meaning is supported by direct physical experience and visual cues. Representative words include dog, chair, ball, apple, run, happy. Vocabulary at this level establishes the foundation for oral and written expression.</p><p>Usage remains restricted to everyday contexts, but words are applied with reliability in speech and simple writing tasks.</p>",
      "level_2_description": "<p>Vocabulary extends to descriptive terms, comparatives, superlatives, and basic prepositions. Words allow for greater variety and precision in communication.</p><p>Opposites and simple synonyms are recognised and applied, supporting categorisation and contrast. Representative examples include bigger, fastest, behind, tomorrow, dark, bright, loud.</p><p>Words at this level expand expressive capacity, enabling more detailed descriptions of people, objects, and events.</p>",
      "level_3_description": "<p>Vocabulary includes subject-related terms across mathematics, science, and the humanities. Words with multiple meanings are understood in context, and figurative expressions emerge in both oral and written language.</p><p>Morphological awareness supports word knowledge, with prefixes and suffixes applied to generate related forms. Examples include continent, fraction, evaporation, unhappy, happiness, planet.</p><p>This level reflects a shift from concrete to abstract vocabulary, supporting comprehension and expression in more academic contexts.</p>",
      "level_4_description": "<p>Vocabulary incorporates a broad range of academic terms across disciplines. Words are understood in both literal and extended senses, showing growth in abstraction and generalisation.</p><p>Representative terms include ecosystem, democracy, investigate, describe, temperature. Precision in use reflects the influence of subject learning on vocabulary expansion.</p><p>Word knowledge at this level underpins independent reading and writing, ensuring comprehension across increasingly challenging texts.</p>",
      "level_5_description": "<p>Vocabulary includes a wide range of technical and academic items. Understanding of Greek and Latin roots supports meaning and spelling, broadening access to complex terms.</p><p>Sensitivity to shades of meaning is evident, with synonyms distinguished by nuance. Examples include justify, evaluate, significance, geology, television, furious, irritated.</p><p>Usage reflects adaptability across contexts, allowing vocabulary to be chosen for formality, audience, and purpose.</p>",
      "level_6_description": "<p>Vocabulary is broad, flexible, and sophisticated. Subject-specific terminology and literary expressions are applied accurately in extended speech and writing.</p><p>Idiomatic language and register are controlled, with awareness of how word choice shapes impact and tone. Representative examples include constitution, parliament, metaphor, equation, persuade, significance.</p><p>At this stage, vocabulary supports advanced comprehension and purposeful, nuanced expression across genres.</p>",
      "level_7_description": "<p>Vocabulary extends to advanced academic and professional domains, including rare, technical, and discipline-specific terms. Connotations, idioms, and cultural references are understood and applied with precision.</p><p>Adaptation to audience and purpose is evident, with word choice reflecting both accuracy and stylistic effect. Representative words include jurisprudence, metamorphosis, synchronisation, ideology, aesthetic.</p><p>Mastery at this level equips students to engage fluently in specialised study, professional communication, and sophisticated expression.</p>"
    }
  },
};

// licenses: {
//   allocation: {
//     toggle_label: "View",
//     grade_label: "Grade",
//     classes_label: "Classes",
//     all_classes_label: "All",
//     students_label: "students",
//     title: "Learner Product License Allocation",
//     select_product_licenses: "Select product licenses to allocate to learners.",

//     table_headers: {
//       first_name: "First Name",
//       last_name: "Last Name",
//       class: "Class",
//     },

//     action_buttons: {
//       cancel: "Cancel",
//       submit: "Submit",
//       search_student: "Search student",
//     },

//     messages: {
//       assignments_submitted_successfully: "Assignments submitted successfully!",
//       failed_to_submit_assignments: "Failed to submit assignments. Please try again.",
//       cannot_assign_more_licenses: "Cannot assign more licenses for {productTitle}. Max seats reached.",
//       only_n_learners_will_be_assigned: "Only {seatsAvailable} learners will be assigned due to max seats limit for {productTitle}."
//     }
//   }
// }

const i18n = createI18n({
  locale: "en-ZA", // Set the default locale
  fallbackLocale: "en-ZA", // Set the fallback locale
  legacy: false,
  globalInjection: true,
  messages,
});

export default i18n;
